var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
function __accessProp(key) {
  return this[key];
}
var __toESMCache_node;
var __toESMCache_esm;
var __toESM = (mod2, isNodeMode, target) => {
  var canCache = mod2 != null && typeof mod2 === "object";
  if (canCache) {
    var cache = isNodeMode ? __toESMCache_node ??= new WeakMap : __toESMCache_esm ??= new WeakMap;
    var cached = cache.get(mod2);
    if (cached)
      return cached;
  }
  target = mod2 != null ? __create(__getProtoOf(mod2)) : {};
  const to = isNodeMode || !mod2 || !mod2.__esModule ? __defProp(target, "default", { value: mod2, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod2))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: __accessProp.bind(mod2, key),
        enumerable: true
      });
  if (canCache)
    cache.set(mod2, to);
  return to;
};
var __commonJS = (cb, mod2) => () => (mod2 || cb((mod2 = { exports: {} }).exports, mod2), mod2.exports);

// ../../node_modules/.bun/@protobufjs+aspromise@1.1.2/node_modules/@protobufjs/aspromise/index.js
var require_aspromise = __commonJS((exports, module) => {
  module.exports = asPromise;
  function asPromise(fn, ctx) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while (index < arguments.length)
      params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
      params[offset] = function callback(err) {
        if (pending) {
          pending = false;
          if (err)
            reject(err);
          else {
            var params2 = new Array(arguments.length - 1), offset2 = 0;
            while (offset2 < params2.length)
              params2[offset2++] = arguments[offset2];
            resolve.apply(null, params2);
          }
        }
      };
      try {
        fn.apply(ctx || null, params);
      } catch (err) {
        if (pending) {
          pending = false;
          reject(err);
        }
      }
    });
  }
});

// ../../node_modules/.bun/@protobufjs+base64@1.1.2/node_modules/@protobufjs/base64/index.js
var require_base64 = __commonJS((exports) => {
  var base64 = exports;
  base64.length = function length(string) {
    var p = string.length;
    if (!p)
      return 0;
    var n = 0;
    while (--p % 4 > 1 && string.charAt(p) === "=")
      ++n;
    return Math.ceil(string.length * 3) / 4 - n;
  };
  var b64 = new Array(64);
  var s64 = new Array(123);
  for (i = 0;i < 64; )
    s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
  var i;
  base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i2 = 0, j = 0, t;
    while (start < end) {
      var b = buffer[start++];
      switch (j) {
        case 0:
          chunk[i2++] = b64[b >> 2];
          t = (b & 3) << 4;
          j = 1;
          break;
        case 1:
          chunk[i2++] = b64[t | b >> 4];
          t = (b & 15) << 2;
          j = 2;
          break;
        case 2:
          chunk[i2++] = b64[t | b >> 6];
          chunk[i2++] = b64[b & 63];
          j = 0;
          break;
      }
      if (i2 > 8191) {
        (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
        i2 = 0;
      }
    }
    if (j) {
      chunk[i2++] = b64[t];
      chunk[i2++] = 61;
      if (j === 1)
        chunk[i2++] = 61;
    }
    if (parts) {
      if (i2)
        parts.push(String.fromCharCode.apply(String, chunk.slice(0, i2)));
      return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i2));
  };
  var invalidEncoding = "invalid encoding";
  base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t;
    for (var i2 = 0;i2 < string.length; ) {
      var c = string.charCodeAt(i2++);
      if (c === 61 && j > 1)
        break;
      if ((c = s64[c]) === undefined)
        throw Error(invalidEncoding);
      switch (j) {
        case 0:
          t = c;
          j = 1;
          break;
        case 1:
          buffer[offset++] = t << 2 | (c & 48) >> 4;
          t = c;
          j = 2;
          break;
        case 2:
          buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
          t = c;
          j = 3;
          break;
        case 3:
          buffer[offset++] = (t & 3) << 6 | c;
          j = 0;
          break;
      }
    }
    if (j === 1)
      throw Error(invalidEncoding);
    return offset - start;
  };
  base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
  };
});

// ../../node_modules/.bun/@protobufjs+eventemitter@1.1.0/node_modules/@protobufjs/eventemitter/index.js
var require_eventemitter = __commonJS((exports, module) => {
  module.exports = EventEmitter;
  function EventEmitter() {
    this._listeners = {};
  }
  EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
      fn,
      ctx: ctx || this
    });
    return this;
  };
  EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined)
      this._listeners = {};
    else {
      if (fn === undefined)
        this._listeners[evt] = [];
      else {
        var listeners = this._listeners[evt];
        for (var i = 0;i < listeners.length; )
          if (listeners[i].fn === fn)
            listeners.splice(i, 1);
          else
            ++i;
      }
    }
    return this;
  };
  EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
      var args = [], i = 1;
      for (;i < arguments.length; )
        args.push(arguments[i++]);
      for (i = 0;i < listeners.length; )
        listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
  };
});

// ../../node_modules/.bun/@protobufjs+float@1.0.2/node_modules/@protobufjs/float/index.js
var require_float = __commonJS((exports, module) => {
  module.exports = factory(factory);
  function factory(exports2) {
    if (typeof Float32Array !== "undefined")
      (function() {
        var f32 = new Float32Array([-0]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
          f32[0] = val;
          buf[pos] = f8b[0];
          buf[pos + 1] = f8b[1];
          buf[pos + 2] = f8b[2];
          buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
          f32[0] = val;
          buf[pos] = f8b[3];
          buf[pos + 1] = f8b[2];
          buf[pos + 2] = f8b[1];
          buf[pos + 3] = f8b[0];
        }
        exports2.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        exports2.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
          f8b[0] = buf[pos];
          f8b[1] = buf[pos + 1];
          f8b[2] = buf[pos + 2];
          f8b[3] = buf[pos + 3];
          return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
          f8b[3] = buf[pos];
          f8b[2] = buf[pos + 1];
          f8b[1] = buf[pos + 2];
          f8b[0] = buf[pos + 3];
          return f32[0];
        }
        exports2.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        exports2.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
      })();
    else
      (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
          var sign = val < 0 ? 1 : 0;
          if (sign)
            val = -val;
          if (val === 0)
            writeUint(1 / val > 0 ? 0 : 2147483648, buf, pos);
          else if (isNaN(val))
            writeUint(2143289344, buf, pos);
          else if (val > 340282346638528860000000000000000000000)
            writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
          else if (val < 0.000000000000000000000000000000000000011754943508222875)
            writeUint((sign << 31 | Math.round(val / 0.000000000000000000000000000000000000000000001401298464324817)) >>> 0, buf, pos);
          else {
            var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
            writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
          }
        }
        exports2.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
        exports2.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
          var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
          return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 ? sign * 0.000000000000000000000000000000000000000000001401298464324817 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports2.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
        exports2.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
      })();
    if (typeof Float64Array !== "undefined")
      (function() {
        var f64 = new Float64Array([-0]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
          f64[0] = val;
          buf[pos] = f8b[0];
          buf[pos + 1] = f8b[1];
          buf[pos + 2] = f8b[2];
          buf[pos + 3] = f8b[3];
          buf[pos + 4] = f8b[4];
          buf[pos + 5] = f8b[5];
          buf[pos + 6] = f8b[6];
          buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
          f64[0] = val;
          buf[pos] = f8b[7];
          buf[pos + 1] = f8b[6];
          buf[pos + 2] = f8b[5];
          buf[pos + 3] = f8b[4];
          buf[pos + 4] = f8b[3];
          buf[pos + 5] = f8b[2];
          buf[pos + 6] = f8b[1];
          buf[pos + 7] = f8b[0];
        }
        exports2.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        exports2.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
          f8b[0] = buf[pos];
          f8b[1] = buf[pos + 1];
          f8b[2] = buf[pos + 2];
          f8b[3] = buf[pos + 3];
          f8b[4] = buf[pos + 4];
          f8b[5] = buf[pos + 5];
          f8b[6] = buf[pos + 6];
          f8b[7] = buf[pos + 7];
          return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
          f8b[7] = buf[pos];
          f8b[6] = buf[pos + 1];
          f8b[5] = buf[pos + 2];
          f8b[4] = buf[pos + 3];
          f8b[3] = buf[pos + 4];
          f8b[2] = buf[pos + 5];
          f8b[1] = buf[pos + 6];
          f8b[0] = buf[pos + 7];
          return f64[0];
        }
        exports2.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        exports2.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
      })();
    else
      (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
          var sign = val < 0 ? 1 : 0;
          if (sign)
            val = -val;
          if (val === 0) {
            writeUint(0, buf, pos + off0);
            writeUint(1 / val > 0 ? 0 : 2147483648, buf, pos + off1);
          } else if (isNaN(val)) {
            writeUint(0, buf, pos + off0);
            writeUint(2146959360, buf, pos + off1);
          } else if (val > 179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000) {
            writeUint(0, buf, pos + off0);
            writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
          } else {
            var mantissa;
            if (val < 0.000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000022250738585072014) {
              mantissa = val / 0.000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005;
              writeUint(mantissa >>> 0, buf, pos + off0);
              writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
            } else {
              var exponent = Math.floor(Math.log(val) / Math.LN2);
              if (exponent === 1024)
                exponent = 1023;
              mantissa = val * Math.pow(2, -exponent);
              writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
              writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
            }
          }
        }
        exports2.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
        exports2.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
          var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
          var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
          return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 ? sign * 0.000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000005 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports2.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
        exports2.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
      })();
    return exports2;
  }
  function writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
  }
  function writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
  }
  function readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
  }
  function readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
  }
});

// ../../node_modules/.bun/@protobufjs+inquire@1.1.0/node_modules/@protobufjs/inquire/index.js
var require_inquire = __commonJS((exports, module) => {
  module.exports = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (e) {}
    return null;
  }
});

// ../../node_modules/.bun/@protobufjs+utf8@1.1.0/node_modules/@protobufjs/utf8/index.js
var require_utf8 = __commonJS((exports) => {
  var utf8 = exports;
  utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for (var i = 0;i < string.length; ++i) {
      c = string.charCodeAt(i);
      if (c < 128)
        len += 1;
      else if (c < 2048)
        len += 2;
      else if ((c & 64512) === 55296 && (string.charCodeAt(i + 1) & 64512) === 56320) {
        ++i;
        len += 4;
      } else
        len += 3;
    }
    return len;
  };
  utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1)
      return "";
    var parts = null, chunk = [], i = 0, t;
    while (start < end) {
      t = buffer[start++];
      if (t < 128)
        chunk[i++] = t;
      else if (t > 191 && t < 224)
        chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
      else if (t > 239 && t < 365) {
        t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 65536;
        chunk[i++] = 55296 + (t >> 10);
        chunk[i++] = 56320 + (t & 1023);
      } else
        chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
      if (i > 8191) {
        (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
        i = 0;
      }
    }
    if (parts) {
      if (i)
        parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
      return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
  };
  utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2;
    for (var i = 0;i < string.length; ++i) {
      c1 = string.charCodeAt(i);
      if (c1 < 128) {
        buffer[offset++] = c1;
      } else if (c1 < 2048) {
        buffer[offset++] = c1 >> 6 | 192;
        buffer[offset++] = c1 & 63 | 128;
      } else if ((c1 & 64512) === 55296 && ((c2 = string.charCodeAt(i + 1)) & 64512) === 56320) {
        c1 = 65536 + ((c1 & 1023) << 10) + (c2 & 1023);
        ++i;
        buffer[offset++] = c1 >> 18 | 240;
        buffer[offset++] = c1 >> 12 & 63 | 128;
        buffer[offset++] = c1 >> 6 & 63 | 128;
        buffer[offset++] = c1 & 63 | 128;
      } else {
        buffer[offset++] = c1 >> 12 | 224;
        buffer[offset++] = c1 >> 6 & 63 | 128;
        buffer[offset++] = c1 & 63 | 128;
      }
    }
    return offset - start;
  };
});

// ../../node_modules/.bun/@protobufjs+pool@1.1.0/node_modules/@protobufjs/pool/index.js
var require_pool = __commonJS((exports, module) => {
  module.exports = pool;
  function pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size2) {
      if (size2 < 1 || size2 > MAX)
        return alloc(size2);
      if (offset + size2 > SIZE) {
        slab = alloc(SIZE);
        offset = 0;
      }
      var buf = slice.call(slab, offset, offset += size2);
      if (offset & 7)
        offset = (offset | 7) + 1;
      return buf;
    };
  }
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/util/longbits.js
var require_longbits = __commonJS((exports, module) => {
  module.exports = LongBits;
  var util = require_minimal();
  function LongBits(lo, hi) {
    this.lo = lo >>> 0;
    this.hi = hi >>> 0;
  }
  var zero = LongBits.zero = new LongBits(0, 0);
  zero.toNumber = function() {
    return 0;
  };
  zero.zzEncode = zero.zzDecode = function() {
    return this;
  };
  zero.length = function() {
    return 1;
  };
  var zeroHash = LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
  LongBits.fromNumber = function fromNumber(value) {
    if (value === 0)
      return zero;
    var sign = value < 0;
    if (sign)
      value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
      hi = ~hi >>> 0;
      lo = ~lo >>> 0;
      if (++lo > 4294967295) {
        lo = 0;
        if (++hi > 4294967295)
          hi = 0;
      }
    }
    return new LongBits(lo, hi);
  };
  LongBits.from = function from(value) {
    if (typeof value === "number")
      return LongBits.fromNumber(value);
    if (util.isString(value)) {
      if (util.Long)
        value = util.Long.fromString(value);
      else
        return LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
  };
  LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
      var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
      if (!lo)
        hi = hi + 1 >>> 0;
      return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  };
  LongBits.prototype.toLong = function toLong(unsigned) {
    return util.Long ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(unsigned) };
  };
  var charCodeAt = String.prototype.charCodeAt;
  LongBits.fromHash = function fromHash(hash) {
    if (hash === zeroHash)
      return zero;
    return new LongBits((charCodeAt.call(hash, 0) | charCodeAt.call(hash, 1) << 8 | charCodeAt.call(hash, 2) << 16 | charCodeAt.call(hash, 3) << 24) >>> 0, (charCodeAt.call(hash, 4) | charCodeAt.call(hash, 5) << 8 | charCodeAt.call(hash, 6) << 16 | charCodeAt.call(hash, 7) << 24) >>> 0);
  };
  LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  };
  LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
  };
  LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
  };
  LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
  };
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/util/minimal.js
var require_minimal = __commonJS((exports) => {
  var util = exports;
  util.asPromise = require_aspromise();
  util.base64 = require_base64();
  util.EventEmitter = require_eventemitter();
  util.float = require_float();
  util.inquire = require_inquire();
  util.utf8 = require_utf8();
  util.pool = require_pool();
  util.LongBits = require_longbits();
  util.isNode = Boolean(typeof global !== "undefined" && global && global.process && global.process.versions && global.process.versions.node);
  util.global = util.isNode && global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || exports;
  util.emptyArray = Object.freeze ? Object.freeze([]) : [];
  util.emptyObject = Object.freeze ? Object.freeze({}) : {};
  util.isInteger = Number.isInteger || function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };
  util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
  };
  util.isObject = function isObject(value) {
    return value && typeof value === "object";
  };
  util.isset = util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop))
      return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
  };
  util.Buffer = function() {
    try {
      var Buffer2 = util.inquire("buffer").Buffer;
      return Buffer2.prototype.utf8Write ? Buffer2 : null;
    } catch (e) {
      return null;
    }
  }();
  util._Buffer_from = null;
  util._Buffer_allocUnsafe = null;
  util.newBuffer = function newBuffer(sizeOrArray) {
    return typeof sizeOrArray === "number" ? util.Buffer ? util._Buffer_allocUnsafe(sizeOrArray) : new util.Array(sizeOrArray) : util.Buffer ? util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
  };
  util.Array = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
  util.Long = util.global.dcodeIO && util.global.dcodeIO.Long || util.global.Long || util.inquire("long");
  util.key2Re = /^true|false|0|1$/;
  util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
  util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
  util.longToHash = function longToHash(value) {
    return value ? util.LongBits.from(value).toHash() : util.LongBits.zeroHash;
  };
  util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = util.LongBits.fromHash(hash);
    if (util.Long)
      return util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
  };
  function merge(dst, src, ifNotSet) {
    for (var keys = Object.keys(src), i = 0;i < keys.length; ++i)
      if (dst[keys[i]] === undefined || !ifNotSet)
        dst[keys[i]] = src[keys[i]];
    return dst;
  }
  util.merge = merge;
  util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
  };
  function newError(name) {
    function CustomError(message, properties) {
      if (!(this instanceof CustomError))
        return new CustomError(message, properties);
      Object.defineProperty(this, "message", { get: function() {
        return message;
      } });
      if (Error.captureStackTrace)
        Error.captureStackTrace(this, CustomError);
      else
        Object.defineProperty(this, "stack", { value: new Error().stack || "" });
      if (properties)
        merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
      constructor: {
        value: CustomError,
        writable: true,
        enumerable: false,
        configurable: true
      },
      name: {
        get: function get() {
          return name;
        },
        set: undefined,
        enumerable: false,
        configurable: true
      },
      toString: {
        value: function value() {
          return this.name + ": " + this.message;
        },
        writable: true,
        enumerable: false,
        configurable: true
      }
    });
    return CustomError;
  }
  util.newError = newError;
  util.ProtocolError = newError("ProtocolError");
  util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for (var i = 0;i < fieldNames.length; ++i)
      fieldMap[fieldNames[i]] = 1;
    return function() {
      for (var keys = Object.keys(this), i2 = keys.length - 1;i2 > -1; --i2)
        if (fieldMap[keys[i2]] === 1 && this[keys[i2]] !== undefined && this[keys[i2]] !== null)
          return keys[i2];
    };
  };
  util.oneOfSetter = function setOneOf(fieldNames) {
    return function(name) {
      for (var i = 0;i < fieldNames.length; ++i)
        if (fieldNames[i] !== name)
          delete this[fieldNames[i]];
    };
  };
  util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
  };
  util._configure = function() {
    var Buffer2 = util.Buffer;
    if (!Buffer2) {
      util._Buffer_from = util._Buffer_allocUnsafe = null;
      return;
    }
    util._Buffer_from = Buffer2.from !== Uint8Array.from && Buffer2.from || function Buffer_from(value, encoding) {
      return new Buffer2(value, encoding);
    };
    util._Buffer_allocUnsafe = Buffer2.allocUnsafe || function Buffer_allocUnsafe(size) {
      return new Buffer2(size);
    };
  };
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/writer.js
var require_writer = __commonJS((exports, module) => {
  module.exports = Writer;
  var util = require_minimal();
  var BufferWriter;
  var LongBits = util.LongBits;
  var base64 = util.base64;
  var utf8 = util.utf8;
  function Op(fn, len, val) {
    this.fn = fn;
    this.len = len;
    this.next = undefined;
    this.val = val;
  }
  function noop() {}
  function State(writer) {
    this.head = writer.head;
    this.tail = writer.tail;
    this.len = writer.len;
    this.next = writer.states;
  }
  function Writer() {
    this.len = 0;
    this.head = new Op(noop, 0, 0);
    this.tail = this.head;
    this.states = null;
  }
  var create = function create2() {
    return util.Buffer ? function create_buffer_setup() {
      return (Writer.create = function create_buffer() {
        return new BufferWriter;
      })();
    } : function create_array() {
      return new Writer;
    };
  };
  Writer.create = create();
  Writer.alloc = function alloc(size) {
    return new util.Array(size);
  };
  if (util.Array !== Array)
    Writer.alloc = util.pool(Writer.alloc, util.Array.prototype.subarray);
  Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new Op(fn, len, val);
    this.len += len;
    return this;
  };
  function writeByte(val, buf, pos) {
    buf[pos] = val & 255;
  }
  function writeVarint32(val, buf, pos) {
    while (val > 127) {
      buf[pos++] = val & 127 | 128;
      val >>>= 7;
    }
    buf[pos] = val;
  }
  function VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
  }
  VarintOp.prototype = Object.create(Op.prototype);
  VarintOp.prototype.fn = writeVarint32;
  Writer.prototype.uint32 = function write_uint32(value) {
    this.len += (this.tail = this.tail.next = new VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
  };
  Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push(writeVarint64, 10, LongBits.fromNumber(value)) : this.uint32(value);
  };
  Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
  };
  function writeVarint64(val, buf, pos) {
    while (val.hi) {
      buf[pos++] = val.lo & 127 | 128;
      val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
      val.hi >>>= 7;
    }
    while (val.lo > 127) {
      buf[pos++] = val.lo & 127 | 128;
      val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
  }
  Writer.prototype.uint64 = function write_uint64(value) {
    var bits = LongBits.from(value);
    return this._push(writeVarint64, bits.length(), bits);
  };
  Writer.prototype.int64 = Writer.prototype.uint64;
  Writer.prototype.sint64 = function write_sint64(value) {
    var bits = LongBits.from(value).zzEncode();
    return this._push(writeVarint64, bits.length(), bits);
  };
  Writer.prototype.bool = function write_bool(value) {
    return this._push(writeByte, 1, value ? 1 : 0);
  };
  function writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
  }
  Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push(writeFixed32, 4, value >>> 0);
  };
  Writer.prototype.sfixed32 = Writer.prototype.fixed32;
  Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = LongBits.from(value);
    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
  };
  Writer.prototype.sfixed64 = Writer.prototype.fixed64;
  Writer.prototype.float = function write_float(value) {
    return this._push(util.float.writeFloatLE, 4, value);
  };
  Writer.prototype.double = function write_double(value) {
    return this._push(util.float.writeDoubleLE, 8, value);
  };
  var writeBytes = util.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos);
  } : function writeBytes_for(val, buf, pos) {
    for (var i = 0;i < val.length; ++i)
      buf[pos + i] = val[i];
  };
  Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len)
      return this._push(writeByte, 1, 0);
    if (util.isString(value)) {
      var buf = Writer.alloc(len = base64.length(value));
      base64.decode(value, buf, 0);
      value = buf;
    }
    return this.uint32(len)._push(writeBytes, len, value);
  };
  Writer.prototype.string = function write_string(value) {
    var len = utf8.length(value);
    return len ? this.uint32(len)._push(utf8.write, len, value) : this._push(writeByte, 1, 0);
  };
  Writer.prototype.fork = function fork() {
    this.states = new State(this);
    this.head = this.tail = new Op(noop, 0, 0);
    this.len = 0;
    return this;
  };
  Writer.prototype.reset = function reset() {
    if (this.states) {
      this.head = this.states.head;
      this.tail = this.states.tail;
      this.len = this.states.len;
      this.states = this.states.next;
    } else {
      this.head = this.tail = new Op(noop, 0, 0);
      this.len = 0;
    }
    return this;
  };
  Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
      this.tail.next = head.next;
      this.tail = tail;
      this.len += len;
    }
    return this;
  };
  Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while (head) {
      head.fn(head.val, buf, pos);
      pos += head.len;
      head = head.next;
    }
    return buf;
  };
  Writer._configure = function(BufferWriter_) {
    BufferWriter = BufferWriter_;
    Writer.create = create();
    BufferWriter._configure();
  };
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/writer_buffer.js
var require_writer_buffer = __commonJS((exports, module) => {
  module.exports = BufferWriter;
  var Writer = require_writer();
  (BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
  var util = require_minimal();
  function BufferWriter() {
    Writer.call(this);
  }
  BufferWriter._configure = function() {
    BufferWriter.alloc = util._Buffer_allocUnsafe;
    BufferWriter.writeBytesBuffer = util.Buffer && util.Buffer.prototype instanceof Uint8Array && util.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
      buf.set(val, pos);
    } : function writeBytesBuffer_copy(val, buf, pos) {
      if (val.copy)
        val.copy(buf, pos, 0, val.length);
      else
        for (var i = 0;i < val.length; )
          buf[pos++] = val[i++];
    };
  };
  BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if (util.isString(value))
      value = util._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len)
      this._push(BufferWriter.writeBytesBuffer, len, value);
    return this;
  };
  function writeStringBuffer(val, buf, pos) {
    if (val.length < 40)
      util.utf8.write(val, buf, pos);
    else if (buf.utf8Write)
      buf.utf8Write(val, pos);
    else
      buf.write(val, pos);
  }
  BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = util.Buffer.byteLength(value);
    this.uint32(len);
    if (len)
      this._push(writeStringBuffer, len, value);
    return this;
  };
  BufferWriter._configure();
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/reader.js
var require_reader = __commonJS((exports, module) => {
  module.exports = Reader;
  var util = require_minimal();
  var BufferReader;
  var LongBits = util.LongBits;
  var utf8 = util.utf8;
  function indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
  }
  function Reader(buffer) {
    this.buf = buffer;
    this.pos = 0;
    this.len = buffer.length;
  }
  var create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer))
      return new Reader(buffer);
    throw Error("illegal buffer");
  } : function create_array2(buffer) {
    if (Array.isArray(buffer))
      return new Reader(buffer);
    throw Error("illegal buffer");
  };
  var create = function create2() {
    return util.Buffer ? function create_buffer_setup(buffer) {
      return (Reader.create = function create_buffer(buffer2) {
        return util.Buffer.isBuffer(buffer2) ? new BufferReader(buffer2) : create_array(buffer2);
      })(buffer);
    } : create_array;
  };
  Reader.create = create();
  Reader.prototype._slice = util.Array.prototype.subarray || util.Array.prototype.slice;
  Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295;
    return function read_uint32() {
      value = (this.buf[this.pos] & 127) >>> 0;
      if (this.buf[this.pos++] < 128)
        return value;
      value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
      if (this.buf[this.pos++] < 128)
        return value;
      value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
      if (this.buf[this.pos++] < 128)
        return value;
      value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
      if (this.buf[this.pos++] < 128)
        return value;
      value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
      if (this.buf[this.pos++] < 128)
        return value;
      if ((this.pos += 5) > this.len) {
        this.pos = this.len;
        throw indexOutOfRange(this, 10);
      }
      return value;
    };
  }();
  Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
  };
  Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
  };
  function readLongVarint() {
    var bits = new LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
      for (;i < 4; ++i) {
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
        if (this.buf[this.pos++] < 128)
          return bits;
      }
      bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
      bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
      if (this.buf[this.pos++] < 128)
        return bits;
      i = 0;
    } else {
      for (;i < 3; ++i) {
        if (this.pos >= this.len)
          throw indexOutOfRange(this);
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
        if (this.buf[this.pos++] < 128)
          return bits;
      }
      bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
      return bits;
    }
    if (this.len - this.pos > 4) {
      for (;i < 5; ++i) {
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128)
          return bits;
      }
    } else {
      for (;i < 5; ++i) {
        if (this.pos >= this.len)
          throw indexOutOfRange(this);
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128)
          return bits;
      }
    }
    throw Error("invalid varint encoding");
  }
  Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
  };
  function readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
  }
  Reader.prototype.fixed32 = function read_fixed32() {
    if (this.pos + 4 > this.len)
      throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4);
  };
  Reader.prototype.sfixed32 = function read_sfixed32() {
    if (this.pos + 4 > this.len)
      throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4) | 0;
  };
  function readFixed64() {
    if (this.pos + 8 > this.len)
      throw indexOutOfRange(this, 8);
    return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
  }
  Reader.prototype.float = function read_float() {
    if (this.pos + 4 > this.len)
      throw indexOutOfRange(this, 4);
    var value = util.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
  };
  Reader.prototype.double = function read_double() {
    if (this.pos + 8 > this.len)
      throw indexOutOfRange(this, 4);
    var value = util.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
  };
  Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    if (end > this.len)
      throw indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf))
      return this.buf.slice(start, end);
    if (start === end) {
      var nativeBuffer = util.Buffer;
      return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
  };
  Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return utf8.read(bytes, 0, bytes.length);
  };
  Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
      if (this.pos + length > this.len)
        throw indexOutOfRange(this, length);
      this.pos += length;
    } else {
      do {
        if (this.pos >= this.len)
          throw indexOutOfRange(this);
      } while (this.buf[this.pos++] & 128);
    }
    return this;
  };
  Reader.prototype.skipType = function(wireType) {
    switch (wireType) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        while ((wireType = this.uint32() & 7) !== 4) {
          this.skipType(wireType);
        }
        break;
      case 5:
        this.skip(4);
        break;
      default:
        throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
  };
  Reader._configure = function(BufferReader_) {
    BufferReader = BufferReader_;
    Reader.create = create();
    BufferReader._configure();
    var fn = util.Long ? "toLong" : "toNumber";
    util.merge(Reader.prototype, {
      int64: function read_int64() {
        return readLongVarint.call(this)[fn](false);
      },
      uint64: function read_uint64() {
        return readLongVarint.call(this)[fn](true);
      },
      sint64: function read_sint64() {
        return readLongVarint.call(this).zzDecode()[fn](false);
      },
      fixed64: function read_fixed64() {
        return readFixed64.call(this)[fn](true);
      },
      sfixed64: function read_sfixed64() {
        return readFixed64.call(this)[fn](false);
      }
    });
  };
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/reader_buffer.js
var require_reader_buffer = __commonJS((exports, module) => {
  module.exports = BufferReader;
  var Reader = require_reader();
  (BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
  var util = require_minimal();
  function BufferReader(buffer) {
    Reader.call(this, buffer);
  }
  BufferReader._configure = function() {
    if (util.Buffer)
      BufferReader.prototype._slice = util.Buffer.prototype.slice;
  };
  BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
  };
  BufferReader._configure();
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/rpc/service.js
var require_service = __commonJS((exports, module) => {
  module.exports = Service;
  var util = require_minimal();
  (Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
  function Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function")
      throw TypeError("rpcImpl must be a function");
    util.EventEmitter.call(this);
    this.rpcImpl = rpcImpl;
    this.requestDelimited = Boolean(requestDelimited);
    this.responseDelimited = Boolean(responseDelimited);
  }
  Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request)
      throw TypeError("request must be specified");
    var self2 = this;
    if (!callback)
      return util.asPromise(rpcCall, self2, method, requestCtor, responseCtor, request);
    if (!self2.rpcImpl) {
      setTimeout(function() {
        callback(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return self2.rpcImpl(method, requestCtor[self2.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
        if (err) {
          self2.emit("error", err, method);
          return callback(err);
        }
        if (response === null) {
          self2.end(true);
          return;
        }
        if (!(response instanceof responseCtor)) {
          try {
            response = responseCtor[self2.responseDelimited ? "decodeDelimited" : "decode"](response);
          } catch (err2) {
            self2.emit("error", err2, method);
            return callback(err2);
          }
        }
        self2.emit("data", response, method);
        return callback(null, response);
      });
    } catch (err) {
      self2.emit("error", err, method);
      setTimeout(function() {
        callback(err);
      }, 0);
      return;
    }
  };
  Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
      if (!endedByRPC)
        this.rpcImpl(null, null, null);
      this.rpcImpl = null;
      this.emit("end").off();
    }
    return this;
  };
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/rpc.js
var require_rpc = __commonJS((exports) => {
  var rpc = exports;
  rpc.Service = require_service();
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/roots.js
var require_roots = __commonJS((exports, module) => {
  module.exports = {};
});

// ../../node_modules/.bun/protobufjs@7.5.4/node_modules/protobufjs/src/index-minimal.js
var require_index_minimal = __commonJS((exports) => {
  var protobuf = exports;
  protobuf.build = "minimal";
  protobuf.Writer = require_writer();
  protobuf.BufferWriter = require_writer_buffer();
  protobuf.Reader = require_reader();
  protobuf.BufferReader = require_reader_buffer();
  protobuf.util = require_minimal();
  protobuf.rpc = require_rpc();
  protobuf.roots = require_roots();
  protobuf.configure = configure;
  function configure() {
    protobuf.util._configure();
    protobuf.Writer._configure(protobuf.BufferWriter);
    protobuf.Reader._configure(protobuf.BufferReader);
  }
  configure();
});

// ../protobuf/dist/bundle.js
var $protobuf = __toESM(require_index_minimal(), 1);
var $Reader = $protobuf.Reader;
var $Writer = $protobuf.Writer;
var $util = $protobuf.util;
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
var codec = $root.codec = (() => {
  const codec2 = {};
  codec2.out = function() {
    const out = {};
    out.ack = function() {
      const ack = {};
      ack.AckPackage = function() {
        function AckPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AckPackage.prototype["package"] = 0;
        AckPackage.prototype.value = 0;
        AckPackage.create = function create(properties) {
          return new AckPackage(properties);
        };
        AckPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
            writer.uint32(8).uint32(message["package"]);
          if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(16).uint32(message.value);
          return writer;
        };
        AckPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AckPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.ack.AckPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message["package"] = reader.uint32();
                break;
              }
              case 2: {
                message.value = reader.uint32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AckPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AckPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message["package"] != null && message.hasOwnProperty("package")) {
            if (!$util.isInteger(message["package"]))
              return "package: integer expected";
          }
          if (message.value != null && message.hasOwnProperty("value")) {
            if (!$util.isInteger(message.value))
              return "value: integer expected";
          }
          return null;
        };
        AckPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.ack.AckPackage)
            return object;
          let message = new $root.codec.out.ack.AckPackage;
          if (object["package"] != null)
            message["package"] = object["package"] >>> 0;
          if (object.value != null)
            message.value = object.value >>> 0;
          return message;
        };
        AckPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object["package"] = 0;
            object.value = 0;
          }
          if (message["package"] != null && message.hasOwnProperty("package"))
            object["package"] = message["package"];
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };
        AckPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        AckPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.ack.AckPackage";
        };
        return AckPackage;
      }();
      return ack;
    }();
    out.automation_report = function() {
      const automation_report = {};
      automation_report.AutomationReportData = function() {
        function AutomationReportData(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AutomationReportData.prototype.auto_idx = 0;
        AutomationReportData.prototype.start_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AutomationReportData.prototype.restart_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AutomationReportData.prototype.end_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        AutomationReportData.prototype.status = 0;
        AutomationReportData.create = function create(properties) {
          return new AutomationReportData(properties);
        };
        AutomationReportData.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.auto_idx != null && Object.hasOwnProperty.call(message, "auto_idx"))
            writer.uint32(8).int32(message.auto_idx);
          if (message.start_time != null && Object.hasOwnProperty.call(message, "start_time"))
            writer.uint32(16).uint64(message.start_time);
          if (message.restart_time != null && Object.hasOwnProperty.call(message, "restart_time"))
            writer.uint32(24).uint64(message.restart_time);
          if (message.end_time != null && Object.hasOwnProperty.call(message, "end_time"))
            writer.uint32(32).uint64(message.end_time);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(40).int32(message.status);
          return writer;
        };
        AutomationReportData.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AutomationReportData.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.automation_report.AutomationReportData;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.auto_idx = reader.int32();
                break;
              }
              case 2: {
                message.start_time = reader.uint64();
                break;
              }
              case 3: {
                message.restart_time = reader.uint64();
                break;
              }
              case 4: {
                message.end_time = reader.uint64();
                break;
              }
              case 5: {
                message.status = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AutomationReportData.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AutomationReportData.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.auto_idx != null && message.hasOwnProperty("auto_idx")) {
            if (!$util.isInteger(message.auto_idx))
              return "auto_idx: integer expected";
          }
          if (message.start_time != null && message.hasOwnProperty("start_time")) {
            if (!$util.isInteger(message.start_time) && !(message.start_time && $util.isInteger(message.start_time.low) && $util.isInteger(message.start_time.high)))
              return "start_time: integer|Long expected";
          }
          if (message.restart_time != null && message.hasOwnProperty("restart_time")) {
            if (!$util.isInteger(message.restart_time) && !(message.restart_time && $util.isInteger(message.restart_time.low) && $util.isInteger(message.restart_time.high)))
              return "restart_time: integer|Long expected";
          }
          if (message.end_time != null && message.hasOwnProperty("end_time")) {
            if (!$util.isInteger(message.end_time) && !(message.end_time && $util.isInteger(message.end_time.low) && $util.isInteger(message.end_time.high)))
              return "end_time: integer|Long expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isInteger(message.status))
              return "status: integer expected";
          }
          return null;
        };
        AutomationReportData.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.automation_report.AutomationReportData)
            return object;
          let message = new $root.codec.out.automation_report.AutomationReportData;
          if (object.auto_idx != null)
            message.auto_idx = object.auto_idx | 0;
          if (object.start_time != null) {
            if ($util.Long)
              (message.start_time = $util.Long.fromValue(object.start_time)).unsigned = true;
            else if (typeof object.start_time === "string")
              message.start_time = parseInt(object.start_time, 10);
            else if (typeof object.start_time === "number")
              message.start_time = object.start_time;
            else if (typeof object.start_time === "object")
              message.start_time = new $util.LongBits(object.start_time.low >>> 0, object.start_time.high >>> 0).toNumber(true);
          }
          if (object.restart_time != null) {
            if ($util.Long)
              (message.restart_time = $util.Long.fromValue(object.restart_time)).unsigned = true;
            else if (typeof object.restart_time === "string")
              message.restart_time = parseInt(object.restart_time, 10);
            else if (typeof object.restart_time === "number")
              message.restart_time = object.restart_time;
            else if (typeof object.restart_time === "object")
              message.restart_time = new $util.LongBits(object.restart_time.low >>> 0, object.restart_time.high >>> 0).toNumber(true);
          }
          if (object.end_time != null) {
            if ($util.Long)
              (message.end_time = $util.Long.fromValue(object.end_time)).unsigned = true;
            else if (typeof object.end_time === "string")
              message.end_time = parseInt(object.end_time, 10);
            else if (typeof object.end_time === "number")
              message.end_time = object.end_time;
            else if (typeof object.end_time === "object")
              message.end_time = new $util.LongBits(object.end_time.low >>> 0, object.end_time.high >>> 0).toNumber(true);
          }
          if (object.status != null)
            message.status = object.status | 0;
          return message;
        };
        AutomationReportData.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.auto_idx = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.start_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.start_time = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.restart_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.restart_time = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.end_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.end_time = options.longs === String ? "0" : 0;
            object.status = 0;
          }
          if (message.auto_idx != null && message.hasOwnProperty("auto_idx"))
            object.auto_idx = message.auto_idx;
          if (message.start_time != null && message.hasOwnProperty("start_time"))
            if (typeof message.start_time === "number")
              object.start_time = options.longs === String ? String(message.start_time) : message.start_time;
            else
              object.start_time = options.longs === String ? $util.Long.prototype.toString.call(message.start_time) : options.longs === Number ? new $util.LongBits(message.start_time.low >>> 0, message.start_time.high >>> 0).toNumber(true) : message.start_time;
          if (message.restart_time != null && message.hasOwnProperty("restart_time"))
            if (typeof message.restart_time === "number")
              object.restart_time = options.longs === String ? String(message.restart_time) : message.restart_time;
            else
              object.restart_time = options.longs === String ? $util.Long.prototype.toString.call(message.restart_time) : options.longs === Number ? new $util.LongBits(message.restart_time.low >>> 0, message.restart_time.high >>> 0).toNumber(true) : message.restart_time;
          if (message.end_time != null && message.hasOwnProperty("end_time"))
            if (typeof message.end_time === "number")
              object.end_time = options.longs === String ? String(message.end_time) : message.end_time;
            else
              object.end_time = options.longs === String ? $util.Long.prototype.toString.call(message.end_time) : options.longs === Number ? new $util.LongBits(message.end_time.low >>> 0, message.end_time.high >>> 0).toNumber(true) : message.end_time;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          return object;
        };
        AutomationReportData.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        AutomationReportData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.automation_report.AutomationReportData";
        };
        return AutomationReportData;
      }();
      automation_report.AutomationReportPackage = function() {
        function AutomationReportPackage(properties) {
          this.data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AutomationReportPackage.prototype.data = $util.emptyArray;
        AutomationReportPackage.create = function create(properties) {
          return new AutomationReportPackage(properties);
        };
        AutomationReportPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.data != null && message.data.length)
            for (let i = 0;i < message.data.length; ++i)
              $root.codec.out.automation_report.AutomationReportData.encode(message.data[i], writer.uint32(10).fork()).ldelim();
          return writer;
        };
        AutomationReportPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AutomationReportPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.automation_report.AutomationReportPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                if (!(message.data && message.data.length))
                  message.data = [];
                message.data.push($root.codec.out.automation_report.AutomationReportData.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AutomationReportPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AutomationReportPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
              return "data: array expected";
            for (let i = 0;i < message.data.length; ++i) {
              let error = $root.codec.out.automation_report.AutomationReportData.verify(message.data[i]);
              if (error)
                return "data." + error;
            }
          }
          return null;
        };
        AutomationReportPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.automation_report.AutomationReportPackage)
            return object;
          let message = new $root.codec.out.automation_report.AutomationReportPackage;
          if (object.data) {
            if (!Array.isArray(object.data))
              throw TypeError(".codec.out.automation_report.AutomationReportPackage.data: array expected");
            message.data = [];
            for (let i = 0;i < object.data.length; ++i) {
              if (typeof object.data[i] !== "object")
                throw TypeError(".codec.out.automation_report.AutomationReportPackage.data: object expected");
              message.data[i] = $root.codec.out.automation_report.AutomationReportData.fromObject(object.data[i]);
            }
          }
          return message;
        };
        AutomationReportPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.data = [];
          if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0;j < message.data.length; ++j)
              object.data[j] = $root.codec.out.automation_report.AutomationReportData.toObject(message.data[j], options);
          }
          return object;
        };
        AutomationReportPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        AutomationReportPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.automation_report.AutomationReportPackage";
        };
        return AutomationReportPackage;
      }();
      return automation_report;
    }();
    out.info = function() {
      const info = {};
      info.InfoPackage = function() {
        function InfoPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        InfoPackage.prototype.codec_id = "";
        InfoPackage.prototype.firmware_esp = 0;
        InfoPackage.prototype.firmware_mesh = 0;
        InfoPackage.prototype.hardware_version = 0;
        InfoPackage.prototype.resets = 0;
        InfoPackage.prototype.scheduling_running = 0;
        InfoPackage.prototype.scheduling_paused = 0;
        InfoPackage.prototype.devices_id = 0;
        InfoPackage.prototype.scheduling_id = 0;
        InfoPackage.prototype.dev_scheduling_id = 0;
        InfoPackage.prototype.automation_id = 0;
        InfoPackage.prototype.config_id = 0;
        InfoPackage.prototype.failed_bitmask = 0;
        InfoPackage.create = function create(properties) {
          return new InfoPackage(properties);
        };
        InfoPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.codec_id != null && Object.hasOwnProperty.call(message, "codec_id"))
            writer.uint32(10).string(message.codec_id);
          if (message.firmware_esp != null && Object.hasOwnProperty.call(message, "firmware_esp"))
            writer.uint32(16).uint32(message.firmware_esp);
          if (message.firmware_mesh != null && Object.hasOwnProperty.call(message, "firmware_mesh"))
            writer.uint32(24).uint32(message.firmware_mesh);
          if (message.hardware_version != null && Object.hasOwnProperty.call(message, "hardware_version"))
            writer.uint32(32).uint32(message.hardware_version);
          if (message.resets != null && Object.hasOwnProperty.call(message, "resets"))
            writer.uint32(40).uint32(message.resets);
          if (message.scheduling_running != null && Object.hasOwnProperty.call(message, "scheduling_running"))
            writer.uint32(48).uint32(message.scheduling_running);
          if (message.scheduling_paused != null && Object.hasOwnProperty.call(message, "scheduling_paused"))
            writer.uint32(56).uint32(message.scheduling_paused);
          if (message.devices_id != null && Object.hasOwnProperty.call(message, "devices_id"))
            writer.uint32(64).uint32(message.devices_id);
          if (message.scheduling_id != null && Object.hasOwnProperty.call(message, "scheduling_id"))
            writer.uint32(72).uint32(message.scheduling_id);
          if (message.dev_scheduling_id != null && Object.hasOwnProperty.call(message, "dev_scheduling_id"))
            writer.uint32(80).uint32(message.dev_scheduling_id);
          if (message.automation_id != null && Object.hasOwnProperty.call(message, "automation_id"))
            writer.uint32(88).uint32(message.automation_id);
          if (message.config_id != null && Object.hasOwnProperty.call(message, "config_id"))
            writer.uint32(96).uint32(message.config_id);
          if (message.failed_bitmask != null && Object.hasOwnProperty.call(message, "failed_bitmask"))
            writer.uint32(104).uint32(message.failed_bitmask);
          return writer;
        };
        InfoPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        InfoPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.info.InfoPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.codec_id = reader.string();
                break;
              }
              case 2: {
                message.firmware_esp = reader.uint32();
                break;
              }
              case 3: {
                message.firmware_mesh = reader.uint32();
                break;
              }
              case 4: {
                message.hardware_version = reader.uint32();
                break;
              }
              case 5: {
                message.resets = reader.uint32();
                break;
              }
              case 6: {
                message.scheduling_running = reader.uint32();
                break;
              }
              case 7: {
                message.scheduling_paused = reader.uint32();
                break;
              }
              case 8: {
                message.devices_id = reader.uint32();
                break;
              }
              case 9: {
                message.scheduling_id = reader.uint32();
                break;
              }
              case 10: {
                message.dev_scheduling_id = reader.uint32();
                break;
              }
              case 11: {
                message.automation_id = reader.uint32();
                break;
              }
              case 12: {
                message.config_id = reader.uint32();
                break;
              }
              case 13: {
                message.failed_bitmask = reader.uint32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        InfoPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        InfoPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.codec_id != null && message.hasOwnProperty("codec_id")) {
            if (!$util.isString(message.codec_id))
              return "codec_id: string expected";
          }
          if (message.firmware_esp != null && message.hasOwnProperty("firmware_esp")) {
            if (!$util.isInteger(message.firmware_esp))
              return "firmware_esp: integer expected";
          }
          if (message.firmware_mesh != null && message.hasOwnProperty("firmware_mesh")) {
            if (!$util.isInteger(message.firmware_mesh))
              return "firmware_mesh: integer expected";
          }
          if (message.hardware_version != null && message.hasOwnProperty("hardware_version")) {
            if (!$util.isInteger(message.hardware_version))
              return "hardware_version: integer expected";
          }
          if (message.resets != null && message.hasOwnProperty("resets")) {
            if (!$util.isInteger(message.resets))
              return "resets: integer expected";
          }
          if (message.scheduling_running != null && message.hasOwnProperty("scheduling_running")) {
            if (!$util.isInteger(message.scheduling_running))
              return "scheduling_running: integer expected";
          }
          if (message.scheduling_paused != null && message.hasOwnProperty("scheduling_paused")) {
            if (!$util.isInteger(message.scheduling_paused))
              return "scheduling_paused: integer expected";
          }
          if (message.devices_id != null && message.hasOwnProperty("devices_id")) {
            if (!$util.isInteger(message.devices_id))
              return "devices_id: integer expected";
          }
          if (message.scheduling_id != null && message.hasOwnProperty("scheduling_id")) {
            if (!$util.isInteger(message.scheduling_id))
              return "scheduling_id: integer expected";
          }
          if (message.dev_scheduling_id != null && message.hasOwnProperty("dev_scheduling_id")) {
            if (!$util.isInteger(message.dev_scheduling_id))
              return "dev_scheduling_id: integer expected";
          }
          if (message.automation_id != null && message.hasOwnProperty("automation_id")) {
            if (!$util.isInteger(message.automation_id))
              return "automation_id: integer expected";
          }
          if (message.config_id != null && message.hasOwnProperty("config_id")) {
            if (!$util.isInteger(message.config_id))
              return "config_id: integer expected";
          }
          if (message.failed_bitmask != null && message.hasOwnProperty("failed_bitmask")) {
            if (!$util.isInteger(message.failed_bitmask))
              return "failed_bitmask: integer expected";
          }
          return null;
        };
        InfoPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.info.InfoPackage)
            return object;
          let message = new $root.codec.out.info.InfoPackage;
          if (object.codec_id != null)
            message.codec_id = String(object.codec_id);
          if (object.firmware_esp != null)
            message.firmware_esp = object.firmware_esp >>> 0;
          if (object.firmware_mesh != null)
            message.firmware_mesh = object.firmware_mesh >>> 0;
          if (object.hardware_version != null)
            message.hardware_version = object.hardware_version >>> 0;
          if (object.resets != null)
            message.resets = object.resets >>> 0;
          if (object.scheduling_running != null)
            message.scheduling_running = object.scheduling_running >>> 0;
          if (object.scheduling_paused != null)
            message.scheduling_paused = object.scheduling_paused >>> 0;
          if (object.devices_id != null)
            message.devices_id = object.devices_id >>> 0;
          if (object.scheduling_id != null)
            message.scheduling_id = object.scheduling_id >>> 0;
          if (object.dev_scheduling_id != null)
            message.dev_scheduling_id = object.dev_scheduling_id >>> 0;
          if (object.automation_id != null)
            message.automation_id = object.automation_id >>> 0;
          if (object.config_id != null)
            message.config_id = object.config_id >>> 0;
          if (object.failed_bitmask != null)
            message.failed_bitmask = object.failed_bitmask >>> 0;
          return message;
        };
        InfoPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.codec_id = "";
            object.firmware_esp = 0;
            object.firmware_mesh = 0;
            object.hardware_version = 0;
            object.resets = 0;
            object.scheduling_running = 0;
            object.scheduling_paused = 0;
            object.devices_id = 0;
            object.scheduling_id = 0;
            object.dev_scheduling_id = 0;
            object.automation_id = 0;
            object.config_id = 0;
            object.failed_bitmask = 0;
          }
          if (message.codec_id != null && message.hasOwnProperty("codec_id"))
            object.codec_id = message.codec_id;
          if (message.firmware_esp != null && message.hasOwnProperty("firmware_esp"))
            object.firmware_esp = message.firmware_esp;
          if (message.firmware_mesh != null && message.hasOwnProperty("firmware_mesh"))
            object.firmware_mesh = message.firmware_mesh;
          if (message.hardware_version != null && message.hasOwnProperty("hardware_version"))
            object.hardware_version = message.hardware_version;
          if (message.resets != null && message.hasOwnProperty("resets"))
            object.resets = message.resets;
          if (message.scheduling_running != null && message.hasOwnProperty("scheduling_running"))
            object.scheduling_running = message.scheduling_running;
          if (message.scheduling_paused != null && message.hasOwnProperty("scheduling_paused"))
            object.scheduling_paused = message.scheduling_paused;
          if (message.devices_id != null && message.hasOwnProperty("devices_id"))
            object.devices_id = message.devices_id;
          if (message.scheduling_id != null && message.hasOwnProperty("scheduling_id"))
            object.scheduling_id = message.scheduling_id;
          if (message.dev_scheduling_id != null && message.hasOwnProperty("dev_scheduling_id"))
            object.dev_scheduling_id = message.dev_scheduling_id;
          if (message.automation_id != null && message.hasOwnProperty("automation_id"))
            object.automation_id = message.automation_id;
          if (message.config_id != null && message.hasOwnProperty("config_id"))
            object.config_id = message.config_id;
          if (message.failed_bitmask != null && message.hasOwnProperty("failed_bitmask"))
            object.failed_bitmask = message.failed_bitmask;
          return object;
        };
        InfoPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        InfoPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.info.InfoPackage";
        };
        return InfoPackage;
      }();
      return info;
    }();
    out.OutgoingPacket = function() {
      function OutgoingPacket(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      OutgoingPacket.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
      OutgoingPacket.prototype.info = null;
      OutgoingPacket.prototype.status = null;
      OutgoingPacket.prototype.scheduling_report = null;
      OutgoingPacket.prototype.automation_report = null;
      OutgoingPacket.prototype.ack = null;
      OutgoingPacket.prototype.raw = null;
      let $oneOfFields;
      Object.defineProperty(OutgoingPacket.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["info", "status", "scheduling_report", "automation_report", "ack", "raw"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      OutgoingPacket.create = function create(properties) {
        return new OutgoingPacket(properties);
      };
      OutgoingPacket.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).uint64(message.id);
        if (message.info != null && Object.hasOwnProperty.call(message, "info"))
          $root.codec.out.info.InfoPackage.encode(message.info, writer.uint32(18).fork()).ldelim();
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
          $root.codec.out.status.SystemStatusPackage.encode(message.status, writer.uint32(26).fork()).ldelim();
        if (message.scheduling_report != null && Object.hasOwnProperty.call(message, "scheduling_report"))
          $root.codec.out.scheduling_report.SchedulingReportPackage.encode(message.scheduling_report, writer.uint32(34).fork()).ldelim();
        if (message.automation_report != null && Object.hasOwnProperty.call(message, "automation_report"))
          $root.codec.out.automation_report.AutomationReportPackage.encode(message.automation_report, writer.uint32(42).fork()).ldelim();
        if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
          $root.codec.out.ack.AckPackage.encode(message.ack, writer.uint32(50).fork()).ldelim();
        if (message.raw != null && Object.hasOwnProperty.call(message, "raw"))
          $root.codec.out.raw.RawPackage.encode(message.raw, writer.uint32(58).fork()).ldelim();
        return writer;
      };
      OutgoingPacket.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      OutgoingPacket.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.OutgoingPacket;
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error)
            break;
          switch (tag >>> 3) {
            case 1: {
              message.id = reader.uint64();
              break;
            }
            case 2: {
              message.info = $root.codec.out.info.InfoPackage.decode(reader, reader.uint32());
              break;
            }
            case 3: {
              message.status = $root.codec.out.status.SystemStatusPackage.decode(reader, reader.uint32());
              break;
            }
            case 4: {
              message.scheduling_report = $root.codec.out.scheduling_report.SchedulingReportPackage.decode(reader, reader.uint32());
              break;
            }
            case 5: {
              message.automation_report = $root.codec.out.automation_report.AutomationReportPackage.decode(reader, reader.uint32());
              break;
            }
            case 6: {
              message.ack = $root.codec.out.ack.AckPackage.decode(reader, reader.uint32());
              break;
            }
            case 7: {
              message.raw = $root.codec.out.raw.RawPackage.decode(reader, reader.uint32());
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      OutgoingPacket.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      OutgoingPacket.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.info != null && message.hasOwnProperty("info")) {
          properties.payload = 1;
          {
            let error = $root.codec.out.info.InfoPackage.verify(message.info);
            if (error)
              return "info." + error;
          }
        }
        if (message.status != null && message.hasOwnProperty("status")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.out.status.SystemStatusPackage.verify(message.status);
            if (error)
              return "status." + error;
          }
        }
        if (message.scheduling_report != null && message.hasOwnProperty("scheduling_report")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.out.scheduling_report.SchedulingReportPackage.verify(message.scheduling_report);
            if (error)
              return "scheduling_report." + error;
          }
        }
        if (message.automation_report != null && message.hasOwnProperty("automation_report")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.out.automation_report.AutomationReportPackage.verify(message.automation_report);
            if (error)
              return "automation_report." + error;
          }
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.out.ack.AckPackage.verify(message.ack);
            if (error)
              return "ack." + error;
          }
        }
        if (message.raw != null && message.hasOwnProperty("raw")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.out.raw.RawPackage.verify(message.raw);
            if (error)
              return "raw." + error;
          }
        }
        return null;
      };
      OutgoingPacket.fromObject = function fromObject(object) {
        if (object instanceof $root.codec.out.OutgoingPacket)
          return object;
        let message = new $root.codec.out.OutgoingPacket;
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = true;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
        }
        if (object.info != null) {
          if (typeof object.info !== "object")
            throw TypeError(".codec.out.OutgoingPacket.info: object expected");
          message.info = $root.codec.out.info.InfoPackage.fromObject(object.info);
        }
        if (object.status != null) {
          if (typeof object.status !== "object")
            throw TypeError(".codec.out.OutgoingPacket.status: object expected");
          message.status = $root.codec.out.status.SystemStatusPackage.fromObject(object.status);
        }
        if (object.scheduling_report != null) {
          if (typeof object.scheduling_report !== "object")
            throw TypeError(".codec.out.OutgoingPacket.scheduling_report: object expected");
          message.scheduling_report = $root.codec.out.scheduling_report.SchedulingReportPackage.fromObject(object.scheduling_report);
        }
        if (object.automation_report != null) {
          if (typeof object.automation_report !== "object")
            throw TypeError(".codec.out.OutgoingPacket.automation_report: object expected");
          message.automation_report = $root.codec.out.automation_report.AutomationReportPackage.fromObject(object.automation_report);
        }
        if (object.ack != null) {
          if (typeof object.ack !== "object")
            throw TypeError(".codec.out.OutgoingPacket.ack: object expected");
          message.ack = $root.codec.out.ack.AckPackage.fromObject(object.ack);
        }
        if (object.raw != null) {
          if (typeof object.raw !== "object")
            throw TypeError(".codec.out.OutgoingPacket.raw: object expected");
          message.raw = $root.codec.out.raw.RawPackage.fromObject(object.raw);
        }
        return message;
      };
      OutgoingPacket.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults)
          if ($util.Long) {
            let long = new $util.Long(0, 0, true);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
        if (message.info != null && message.hasOwnProperty("info")) {
          object.info = $root.codec.out.info.InfoPackage.toObject(message.info, options);
          if (options.oneofs)
            object.payload = "info";
        }
        if (message.status != null && message.hasOwnProperty("status")) {
          object.status = $root.codec.out.status.SystemStatusPackage.toObject(message.status, options);
          if (options.oneofs)
            object.payload = "status";
        }
        if (message.scheduling_report != null && message.hasOwnProperty("scheduling_report")) {
          object.scheduling_report = $root.codec.out.scheduling_report.SchedulingReportPackage.toObject(message.scheduling_report, options);
          if (options.oneofs)
            object.payload = "scheduling_report";
        }
        if (message.automation_report != null && message.hasOwnProperty("automation_report")) {
          object.automation_report = $root.codec.out.automation_report.AutomationReportPackage.toObject(message.automation_report, options);
          if (options.oneofs)
            object.payload = "automation_report";
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
          object.ack = $root.codec.out.ack.AckPackage.toObject(message.ack, options);
          if (options.oneofs)
            object.payload = "ack";
        }
        if (message.raw != null && message.hasOwnProperty("raw")) {
          object.raw = $root.codec.out.raw.RawPackage.toObject(message.raw, options);
          if (options.oneofs)
            object.payload = "raw";
        }
        return object;
      };
      OutgoingPacket.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      OutgoingPacket.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/codec.out.OutgoingPacket";
      };
      return OutgoingPacket;
    }();
    out.status = function() {
      const status = {};
      status.SystemStatusPackage = function() {
        function SystemStatusPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        SystemStatusPackage.prototype.resets = 0;
        SystemStatusPackage.prototype.scheduling_running = 0;
        SystemStatusPackage.prototype.scheduling_paused = 0;
        SystemStatusPackage.prototype.paused_time = null;
        SystemStatusPackage.prototype.raining = null;
        SystemStatusPackage.prototype.rainfall = null;
        SystemStatusPackage.prototype.rainfall_global_count = null;
        SystemStatusPackage.prototype.sync_bitmask = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SystemStatusPackage.prototype.on_bitmask = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SystemStatusPackage.prototype.input_bitmask = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SystemStatusPackage.prototype.failed_bitmask = 0;
        let $oneOfFields;
        Object.defineProperty(SystemStatusPackage.prototype, "has_paused_time", {
          get: $util.oneOfGetter($oneOfFields = ["paused_time"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(SystemStatusPackage.prototype, "has_raining", {
          get: $util.oneOfGetter($oneOfFields = ["raining"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(SystemStatusPackage.prototype, "has_rainfall", {
          get: $util.oneOfGetter($oneOfFields = ["rainfall"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        Object.defineProperty(SystemStatusPackage.prototype, "has_rainfall_global_count", {
          get: $util.oneOfGetter($oneOfFields = ["rainfall_global_count"]),
          set: $util.oneOfSetter($oneOfFields)
        });
        SystemStatusPackage.create = function create(properties) {
          return new SystemStatusPackage(properties);
        };
        SystemStatusPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.resets != null && Object.hasOwnProperty.call(message, "resets"))
            writer.uint32(8).uint32(message.resets);
          if (message.scheduling_running != null && Object.hasOwnProperty.call(message, "scheduling_running"))
            writer.uint32(16).uint32(message.scheduling_running);
          if (message.scheduling_paused != null && Object.hasOwnProperty.call(message, "scheduling_paused"))
            writer.uint32(24).uint32(message.scheduling_paused);
          if (message.paused_time != null && Object.hasOwnProperty.call(message, "paused_time"))
            writer.uint32(32).uint32(message.paused_time);
          if (message.raining != null && Object.hasOwnProperty.call(message, "raining"))
            writer.uint32(40).uint32(message.raining);
          if (message.rainfall != null && Object.hasOwnProperty.call(message, "rainfall"))
            writer.uint32(48).uint32(message.rainfall);
          if (message.sync_bitmask != null && Object.hasOwnProperty.call(message, "sync_bitmask"))
            writer.uint32(56).uint64(message.sync_bitmask);
          if (message.on_bitmask != null && Object.hasOwnProperty.call(message, "on_bitmask"))
            writer.uint32(64).uint64(message.on_bitmask);
          if (message.input_bitmask != null && Object.hasOwnProperty.call(message, "input_bitmask"))
            writer.uint32(72).uint64(message.input_bitmask);
          if (message.rainfall_global_count != null && Object.hasOwnProperty.call(message, "rainfall_global_count"))
            writer.uint32(80).uint32(message.rainfall_global_count);
          if (message.failed_bitmask != null && Object.hasOwnProperty.call(message, "failed_bitmask"))
            writer.uint32(96).uint32(message.failed_bitmask);
          return writer;
        };
        SystemStatusPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        SystemStatusPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.status.SystemStatusPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.resets = reader.uint32();
                break;
              }
              case 2: {
                message.scheduling_running = reader.uint32();
                break;
              }
              case 3: {
                message.scheduling_paused = reader.uint32();
                break;
              }
              case 4: {
                message.paused_time = reader.uint32();
                break;
              }
              case 5: {
                message.raining = reader.uint32();
                break;
              }
              case 6: {
                message.rainfall = reader.uint32();
                break;
              }
              case 10: {
                message.rainfall_global_count = reader.uint32();
                break;
              }
              case 7: {
                message.sync_bitmask = reader.uint64();
                break;
              }
              case 8: {
                message.on_bitmask = reader.uint64();
                break;
              }
              case 9: {
                message.input_bitmask = reader.uint64();
                break;
              }
              case 12: {
                message.failed_bitmask = reader.uint32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        SystemStatusPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        SystemStatusPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          let properties = {};
          if (message.resets != null && message.hasOwnProperty("resets")) {
            if (!$util.isInteger(message.resets))
              return "resets: integer expected";
          }
          if (message.scheduling_running != null && message.hasOwnProperty("scheduling_running")) {
            if (!$util.isInteger(message.scheduling_running))
              return "scheduling_running: integer expected";
          }
          if (message.scheduling_paused != null && message.hasOwnProperty("scheduling_paused")) {
            if (!$util.isInteger(message.scheduling_paused))
              return "scheduling_paused: integer expected";
          }
          if (message.paused_time != null && message.hasOwnProperty("paused_time")) {
            properties.has_paused_time = 1;
            if (!$util.isInteger(message.paused_time))
              return "paused_time: integer expected";
          }
          if (message.raining != null && message.hasOwnProperty("raining")) {
            properties.has_raining = 1;
            if (!$util.isInteger(message.raining))
              return "raining: integer expected";
          }
          if (message.rainfall != null && message.hasOwnProperty("rainfall")) {
            properties.has_rainfall = 1;
            if (!$util.isInteger(message.rainfall))
              return "rainfall: integer expected";
          }
          if (message.rainfall_global_count != null && message.hasOwnProperty("rainfall_global_count")) {
            properties.has_rainfall_global_count = 1;
            if (!$util.isInteger(message.rainfall_global_count))
              return "rainfall_global_count: integer expected";
          }
          if (message.sync_bitmask != null && message.hasOwnProperty("sync_bitmask")) {
            if (!$util.isInteger(message.sync_bitmask) && !(message.sync_bitmask && $util.isInteger(message.sync_bitmask.low) && $util.isInteger(message.sync_bitmask.high)))
              return "sync_bitmask: integer|Long expected";
          }
          if (message.on_bitmask != null && message.hasOwnProperty("on_bitmask")) {
            if (!$util.isInteger(message.on_bitmask) && !(message.on_bitmask && $util.isInteger(message.on_bitmask.low) && $util.isInteger(message.on_bitmask.high)))
              return "on_bitmask: integer|Long expected";
          }
          if (message.input_bitmask != null && message.hasOwnProperty("input_bitmask")) {
            if (!$util.isInteger(message.input_bitmask) && !(message.input_bitmask && $util.isInteger(message.input_bitmask.low) && $util.isInteger(message.input_bitmask.high)))
              return "input_bitmask: integer|Long expected";
          }
          if (message.failed_bitmask != null && message.hasOwnProperty("failed_bitmask")) {
            if (!$util.isInteger(message.failed_bitmask))
              return "failed_bitmask: integer expected";
          }
          return null;
        };
        SystemStatusPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.status.SystemStatusPackage)
            return object;
          let message = new $root.codec.out.status.SystemStatusPackage;
          if (object.resets != null)
            message.resets = object.resets >>> 0;
          if (object.scheduling_running != null)
            message.scheduling_running = object.scheduling_running >>> 0;
          if (object.scheduling_paused != null)
            message.scheduling_paused = object.scheduling_paused >>> 0;
          if (object.paused_time != null)
            message.paused_time = object.paused_time >>> 0;
          if (object.raining != null)
            message.raining = object.raining >>> 0;
          if (object.rainfall != null)
            message.rainfall = object.rainfall >>> 0;
          if (object.rainfall_global_count != null)
            message.rainfall_global_count = object.rainfall_global_count >>> 0;
          if (object.sync_bitmask != null) {
            if ($util.Long)
              (message.sync_bitmask = $util.Long.fromValue(object.sync_bitmask)).unsigned = true;
            else if (typeof object.sync_bitmask === "string")
              message.sync_bitmask = parseInt(object.sync_bitmask, 10);
            else if (typeof object.sync_bitmask === "number")
              message.sync_bitmask = object.sync_bitmask;
            else if (typeof object.sync_bitmask === "object")
              message.sync_bitmask = new $util.LongBits(object.sync_bitmask.low >>> 0, object.sync_bitmask.high >>> 0).toNumber(true);
          }
          if (object.on_bitmask != null) {
            if ($util.Long)
              (message.on_bitmask = $util.Long.fromValue(object.on_bitmask)).unsigned = true;
            else if (typeof object.on_bitmask === "string")
              message.on_bitmask = parseInt(object.on_bitmask, 10);
            else if (typeof object.on_bitmask === "number")
              message.on_bitmask = object.on_bitmask;
            else if (typeof object.on_bitmask === "object")
              message.on_bitmask = new $util.LongBits(object.on_bitmask.low >>> 0, object.on_bitmask.high >>> 0).toNumber(true);
          }
          if (object.input_bitmask != null) {
            if ($util.Long)
              (message.input_bitmask = $util.Long.fromValue(object.input_bitmask)).unsigned = true;
            else if (typeof object.input_bitmask === "string")
              message.input_bitmask = parseInt(object.input_bitmask, 10);
            else if (typeof object.input_bitmask === "number")
              message.input_bitmask = object.input_bitmask;
            else if (typeof object.input_bitmask === "object")
              message.input_bitmask = new $util.LongBits(object.input_bitmask.low >>> 0, object.input_bitmask.high >>> 0).toNumber(true);
          }
          if (object.failed_bitmask != null)
            message.failed_bitmask = object.failed_bitmask >>> 0;
          return message;
        };
        SystemStatusPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.resets = 0;
            object.scheduling_running = 0;
            object.scheduling_paused = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.sync_bitmask = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.sync_bitmask = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.on_bitmask = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.on_bitmask = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.input_bitmask = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.input_bitmask = options.longs === String ? "0" : 0;
            object.failed_bitmask = 0;
          }
          if (message.resets != null && message.hasOwnProperty("resets"))
            object.resets = message.resets;
          if (message.scheduling_running != null && message.hasOwnProperty("scheduling_running"))
            object.scheduling_running = message.scheduling_running;
          if (message.scheduling_paused != null && message.hasOwnProperty("scheduling_paused"))
            object.scheduling_paused = message.scheduling_paused;
          if (message.paused_time != null && message.hasOwnProperty("paused_time")) {
            object.paused_time = message.paused_time;
            if (options.oneofs)
              object.has_paused_time = "paused_time";
          }
          if (message.raining != null && message.hasOwnProperty("raining")) {
            object.raining = message.raining;
            if (options.oneofs)
              object.has_raining = "raining";
          }
          if (message.rainfall != null && message.hasOwnProperty("rainfall")) {
            object.rainfall = message.rainfall;
            if (options.oneofs)
              object.has_rainfall = "rainfall";
          }
          if (message.sync_bitmask != null && message.hasOwnProperty("sync_bitmask"))
            if (typeof message.sync_bitmask === "number")
              object.sync_bitmask = options.longs === String ? String(message.sync_bitmask) : message.sync_bitmask;
            else
              object.sync_bitmask = options.longs === String ? $util.Long.prototype.toString.call(message.sync_bitmask) : options.longs === Number ? new $util.LongBits(message.sync_bitmask.low >>> 0, message.sync_bitmask.high >>> 0).toNumber(true) : message.sync_bitmask;
          if (message.on_bitmask != null && message.hasOwnProperty("on_bitmask"))
            if (typeof message.on_bitmask === "number")
              object.on_bitmask = options.longs === String ? String(message.on_bitmask) : message.on_bitmask;
            else
              object.on_bitmask = options.longs === String ? $util.Long.prototype.toString.call(message.on_bitmask) : options.longs === Number ? new $util.LongBits(message.on_bitmask.low >>> 0, message.on_bitmask.high >>> 0).toNumber(true) : message.on_bitmask;
          if (message.input_bitmask != null && message.hasOwnProperty("input_bitmask"))
            if (typeof message.input_bitmask === "number")
              object.input_bitmask = options.longs === String ? String(message.input_bitmask) : message.input_bitmask;
            else
              object.input_bitmask = options.longs === String ? $util.Long.prototype.toString.call(message.input_bitmask) : options.longs === Number ? new $util.LongBits(message.input_bitmask.low >>> 0, message.input_bitmask.high >>> 0).toNumber(true) : message.input_bitmask;
          if (message.rainfall_global_count != null && message.hasOwnProperty("rainfall_global_count")) {
            object.rainfall_global_count = message.rainfall_global_count;
            if (options.oneofs)
              object.has_rainfall_global_count = "rainfall_global_count";
          }
          if (message.failed_bitmask != null && message.hasOwnProperty("failed_bitmask"))
            object.failed_bitmask = message.failed_bitmask;
          return object;
        };
        SystemStatusPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        SystemStatusPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.status.SystemStatusPackage";
        };
        return SystemStatusPackage;
      }();
      return status;
    }();
    out.scheduling_report = function() {
      const scheduling_report = {};
      scheduling_report.SchedulingReportData = function() {
        function SchedulingReportData(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        SchedulingReportData.prototype.scheduling_idx = 0;
        SchedulingReportData.prototype.start_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.end_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.sector_bitmask1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.sector_bitmask2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.ferti_bitmask1 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.ferti_bitmask2 = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.waterpump = false;
        SchedulingReportData.prototype.backwash_time = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.number_of_sectors = 0;
        SchedulingReportData.prototype.had_waterpump = false;
        SchedulingReportData.prototype.had_ferti = false;
        SchedulingReportData.prototype.time_of_resumption = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        SchedulingReportData.prototype.resumption_attempts = 0;
        SchedulingReportData.prototype.status = 0;
        SchedulingReportData.create = function create(properties) {
          return new SchedulingReportData(properties);
        };
        SchedulingReportData.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.scheduling_idx != null && Object.hasOwnProperty.call(message, "scheduling_idx"))
            writer.uint32(8).int32(message.scheduling_idx);
          if (message.start_time != null && Object.hasOwnProperty.call(message, "start_time"))
            writer.uint32(16).uint64(message.start_time);
          if (message.end_time != null && Object.hasOwnProperty.call(message, "end_time"))
            writer.uint32(24).uint64(message.end_time);
          if (message.sector_bitmask1 != null && Object.hasOwnProperty.call(message, "sector_bitmask1"))
            writer.uint32(32).uint64(message.sector_bitmask1);
          if (message.sector_bitmask2 != null && Object.hasOwnProperty.call(message, "sector_bitmask2"))
            writer.uint32(40).uint64(message.sector_bitmask2);
          if (message.ferti_bitmask1 != null && Object.hasOwnProperty.call(message, "ferti_bitmask1"))
            writer.uint32(48).uint64(message.ferti_bitmask1);
          if (message.ferti_bitmask2 != null && Object.hasOwnProperty.call(message, "ferti_bitmask2"))
            writer.uint32(56).uint64(message.ferti_bitmask2);
          if (message.waterpump != null && Object.hasOwnProperty.call(message, "waterpump"))
            writer.uint32(64).bool(message.waterpump);
          if (message.backwash_time != null && Object.hasOwnProperty.call(message, "backwash_time"))
            writer.uint32(72).uint64(message.backwash_time);
          if (message.number_of_sectors != null && Object.hasOwnProperty.call(message, "number_of_sectors"))
            writer.uint32(80).int32(message.number_of_sectors);
          if (message.had_waterpump != null && Object.hasOwnProperty.call(message, "had_waterpump"))
            writer.uint32(88).bool(message.had_waterpump);
          if (message.had_ferti != null && Object.hasOwnProperty.call(message, "had_ferti"))
            writer.uint32(96).bool(message.had_ferti);
          if (message.time_of_resumption != null && Object.hasOwnProperty.call(message, "time_of_resumption"))
            writer.uint32(104).uint64(message.time_of_resumption);
          if (message.resumption_attempts != null && Object.hasOwnProperty.call(message, "resumption_attempts"))
            writer.uint32(112).int32(message.resumption_attempts);
          if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(120).int32(message.status);
          return writer;
        };
        SchedulingReportData.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        SchedulingReportData.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.scheduling_report.SchedulingReportData;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.scheduling_idx = reader.int32();
                break;
              }
              case 2: {
                message.start_time = reader.uint64();
                break;
              }
              case 3: {
                message.end_time = reader.uint64();
                break;
              }
              case 4: {
                message.sector_bitmask1 = reader.uint64();
                break;
              }
              case 5: {
                message.sector_bitmask2 = reader.uint64();
                break;
              }
              case 6: {
                message.ferti_bitmask1 = reader.uint64();
                break;
              }
              case 7: {
                message.ferti_bitmask2 = reader.uint64();
                break;
              }
              case 8: {
                message.waterpump = reader.bool();
                break;
              }
              case 9: {
                message.backwash_time = reader.uint64();
                break;
              }
              case 10: {
                message.number_of_sectors = reader.int32();
                break;
              }
              case 11: {
                message.had_waterpump = reader.bool();
                break;
              }
              case 12: {
                message.had_ferti = reader.bool();
                break;
              }
              case 13: {
                message.time_of_resumption = reader.uint64();
                break;
              }
              case 14: {
                message.resumption_attempts = reader.int32();
                break;
              }
              case 15: {
                message.status = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        SchedulingReportData.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        SchedulingReportData.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx")) {
            if (!$util.isInteger(message.scheduling_idx))
              return "scheduling_idx: integer expected";
          }
          if (message.start_time != null && message.hasOwnProperty("start_time")) {
            if (!$util.isInteger(message.start_time) && !(message.start_time && $util.isInteger(message.start_time.low) && $util.isInteger(message.start_time.high)))
              return "start_time: integer|Long expected";
          }
          if (message.end_time != null && message.hasOwnProperty("end_time")) {
            if (!$util.isInteger(message.end_time) && !(message.end_time && $util.isInteger(message.end_time.low) && $util.isInteger(message.end_time.high)))
              return "end_time: integer|Long expected";
          }
          if (message.sector_bitmask1 != null && message.hasOwnProperty("sector_bitmask1")) {
            if (!$util.isInteger(message.sector_bitmask1) && !(message.sector_bitmask1 && $util.isInteger(message.sector_bitmask1.low) && $util.isInteger(message.sector_bitmask1.high)))
              return "sector_bitmask1: integer|Long expected";
          }
          if (message.sector_bitmask2 != null && message.hasOwnProperty("sector_bitmask2")) {
            if (!$util.isInteger(message.sector_bitmask2) && !(message.sector_bitmask2 && $util.isInteger(message.sector_bitmask2.low) && $util.isInteger(message.sector_bitmask2.high)))
              return "sector_bitmask2: integer|Long expected";
          }
          if (message.ferti_bitmask1 != null && message.hasOwnProperty("ferti_bitmask1")) {
            if (!$util.isInteger(message.ferti_bitmask1) && !(message.ferti_bitmask1 && $util.isInteger(message.ferti_bitmask1.low) && $util.isInteger(message.ferti_bitmask1.high)))
              return "ferti_bitmask1: integer|Long expected";
          }
          if (message.ferti_bitmask2 != null && message.hasOwnProperty("ferti_bitmask2")) {
            if (!$util.isInteger(message.ferti_bitmask2) && !(message.ferti_bitmask2 && $util.isInteger(message.ferti_bitmask2.low) && $util.isInteger(message.ferti_bitmask2.high)))
              return "ferti_bitmask2: integer|Long expected";
          }
          if (message.waterpump != null && message.hasOwnProperty("waterpump")) {
            if (typeof message.waterpump !== "boolean")
              return "waterpump: boolean expected";
          }
          if (message.backwash_time != null && message.hasOwnProperty("backwash_time")) {
            if (!$util.isInteger(message.backwash_time) && !(message.backwash_time && $util.isInteger(message.backwash_time.low) && $util.isInteger(message.backwash_time.high)))
              return "backwash_time: integer|Long expected";
          }
          if (message.number_of_sectors != null && message.hasOwnProperty("number_of_sectors")) {
            if (!$util.isInteger(message.number_of_sectors))
              return "number_of_sectors: integer expected";
          }
          if (message.had_waterpump != null && message.hasOwnProperty("had_waterpump")) {
            if (typeof message.had_waterpump !== "boolean")
              return "had_waterpump: boolean expected";
          }
          if (message.had_ferti != null && message.hasOwnProperty("had_ferti")) {
            if (typeof message.had_ferti !== "boolean")
              return "had_ferti: boolean expected";
          }
          if (message.time_of_resumption != null && message.hasOwnProperty("time_of_resumption")) {
            if (!$util.isInteger(message.time_of_resumption) && !(message.time_of_resumption && $util.isInteger(message.time_of_resumption.low) && $util.isInteger(message.time_of_resumption.high)))
              return "time_of_resumption: integer|Long expected";
          }
          if (message.resumption_attempts != null && message.hasOwnProperty("resumption_attempts")) {
            if (!$util.isInteger(message.resumption_attempts))
              return "resumption_attempts: integer expected";
          }
          if (message.status != null && message.hasOwnProperty("status")) {
            if (!$util.isInteger(message.status))
              return "status: integer expected";
          }
          return null;
        };
        SchedulingReportData.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.scheduling_report.SchedulingReportData)
            return object;
          let message = new $root.codec.out.scheduling_report.SchedulingReportData;
          if (object.scheduling_idx != null)
            message.scheduling_idx = object.scheduling_idx | 0;
          if (object.start_time != null) {
            if ($util.Long)
              (message.start_time = $util.Long.fromValue(object.start_time)).unsigned = true;
            else if (typeof object.start_time === "string")
              message.start_time = parseInt(object.start_time, 10);
            else if (typeof object.start_time === "number")
              message.start_time = object.start_time;
            else if (typeof object.start_time === "object")
              message.start_time = new $util.LongBits(object.start_time.low >>> 0, object.start_time.high >>> 0).toNumber(true);
          }
          if (object.end_time != null) {
            if ($util.Long)
              (message.end_time = $util.Long.fromValue(object.end_time)).unsigned = true;
            else if (typeof object.end_time === "string")
              message.end_time = parseInt(object.end_time, 10);
            else if (typeof object.end_time === "number")
              message.end_time = object.end_time;
            else if (typeof object.end_time === "object")
              message.end_time = new $util.LongBits(object.end_time.low >>> 0, object.end_time.high >>> 0).toNumber(true);
          }
          if (object.sector_bitmask1 != null) {
            if ($util.Long)
              (message.sector_bitmask1 = $util.Long.fromValue(object.sector_bitmask1)).unsigned = true;
            else if (typeof object.sector_bitmask1 === "string")
              message.sector_bitmask1 = parseInt(object.sector_bitmask1, 10);
            else if (typeof object.sector_bitmask1 === "number")
              message.sector_bitmask1 = object.sector_bitmask1;
            else if (typeof object.sector_bitmask1 === "object")
              message.sector_bitmask1 = new $util.LongBits(object.sector_bitmask1.low >>> 0, object.sector_bitmask1.high >>> 0).toNumber(true);
          }
          if (object.sector_bitmask2 != null) {
            if ($util.Long)
              (message.sector_bitmask2 = $util.Long.fromValue(object.sector_bitmask2)).unsigned = true;
            else if (typeof object.sector_bitmask2 === "string")
              message.sector_bitmask2 = parseInt(object.sector_bitmask2, 10);
            else if (typeof object.sector_bitmask2 === "number")
              message.sector_bitmask2 = object.sector_bitmask2;
            else if (typeof object.sector_bitmask2 === "object")
              message.sector_bitmask2 = new $util.LongBits(object.sector_bitmask2.low >>> 0, object.sector_bitmask2.high >>> 0).toNumber(true);
          }
          if (object.ferti_bitmask1 != null) {
            if ($util.Long)
              (message.ferti_bitmask1 = $util.Long.fromValue(object.ferti_bitmask1)).unsigned = true;
            else if (typeof object.ferti_bitmask1 === "string")
              message.ferti_bitmask1 = parseInt(object.ferti_bitmask1, 10);
            else if (typeof object.ferti_bitmask1 === "number")
              message.ferti_bitmask1 = object.ferti_bitmask1;
            else if (typeof object.ferti_bitmask1 === "object")
              message.ferti_bitmask1 = new $util.LongBits(object.ferti_bitmask1.low >>> 0, object.ferti_bitmask1.high >>> 0).toNumber(true);
          }
          if (object.ferti_bitmask2 != null) {
            if ($util.Long)
              (message.ferti_bitmask2 = $util.Long.fromValue(object.ferti_bitmask2)).unsigned = true;
            else if (typeof object.ferti_bitmask2 === "string")
              message.ferti_bitmask2 = parseInt(object.ferti_bitmask2, 10);
            else if (typeof object.ferti_bitmask2 === "number")
              message.ferti_bitmask2 = object.ferti_bitmask2;
            else if (typeof object.ferti_bitmask2 === "object")
              message.ferti_bitmask2 = new $util.LongBits(object.ferti_bitmask2.low >>> 0, object.ferti_bitmask2.high >>> 0).toNumber(true);
          }
          if (object.waterpump != null)
            message.waterpump = Boolean(object.waterpump);
          if (object.backwash_time != null) {
            if ($util.Long)
              (message.backwash_time = $util.Long.fromValue(object.backwash_time)).unsigned = true;
            else if (typeof object.backwash_time === "string")
              message.backwash_time = parseInt(object.backwash_time, 10);
            else if (typeof object.backwash_time === "number")
              message.backwash_time = object.backwash_time;
            else if (typeof object.backwash_time === "object")
              message.backwash_time = new $util.LongBits(object.backwash_time.low >>> 0, object.backwash_time.high >>> 0).toNumber(true);
          }
          if (object.number_of_sectors != null)
            message.number_of_sectors = object.number_of_sectors | 0;
          if (object.had_waterpump != null)
            message.had_waterpump = Boolean(object.had_waterpump);
          if (object.had_ferti != null)
            message.had_ferti = Boolean(object.had_ferti);
          if (object.time_of_resumption != null) {
            if ($util.Long)
              (message.time_of_resumption = $util.Long.fromValue(object.time_of_resumption)).unsigned = true;
            else if (typeof object.time_of_resumption === "string")
              message.time_of_resumption = parseInt(object.time_of_resumption, 10);
            else if (typeof object.time_of_resumption === "number")
              message.time_of_resumption = object.time_of_resumption;
            else if (typeof object.time_of_resumption === "object")
              message.time_of_resumption = new $util.LongBits(object.time_of_resumption.low >>> 0, object.time_of_resumption.high >>> 0).toNumber(true);
          }
          if (object.resumption_attempts != null)
            message.resumption_attempts = object.resumption_attempts | 0;
          if (object.status != null)
            message.status = object.status | 0;
          return message;
        };
        SchedulingReportData.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.scheduling_idx = 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.start_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.start_time = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.end_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.end_time = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.sector_bitmask1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.sector_bitmask1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.sector_bitmask2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.sector_bitmask2 = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.ferti_bitmask1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.ferti_bitmask1 = options.longs === String ? "0" : 0;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.ferti_bitmask2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.ferti_bitmask2 = options.longs === String ? "0" : 0;
            object.waterpump = false;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.backwash_time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.backwash_time = options.longs === String ? "0" : 0;
            object.number_of_sectors = 0;
            object.had_waterpump = false;
            object.had_ferti = false;
            if ($util.Long) {
              let long = new $util.Long(0, 0, true);
              object.time_of_resumption = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
              object.time_of_resumption = options.longs === String ? "0" : 0;
            object.resumption_attempts = 0;
            object.status = 0;
          }
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx"))
            object.scheduling_idx = message.scheduling_idx;
          if (message.start_time != null && message.hasOwnProperty("start_time"))
            if (typeof message.start_time === "number")
              object.start_time = options.longs === String ? String(message.start_time) : message.start_time;
            else
              object.start_time = options.longs === String ? $util.Long.prototype.toString.call(message.start_time) : options.longs === Number ? new $util.LongBits(message.start_time.low >>> 0, message.start_time.high >>> 0).toNumber(true) : message.start_time;
          if (message.end_time != null && message.hasOwnProperty("end_time"))
            if (typeof message.end_time === "number")
              object.end_time = options.longs === String ? String(message.end_time) : message.end_time;
            else
              object.end_time = options.longs === String ? $util.Long.prototype.toString.call(message.end_time) : options.longs === Number ? new $util.LongBits(message.end_time.low >>> 0, message.end_time.high >>> 0).toNumber(true) : message.end_time;
          if (message.sector_bitmask1 != null && message.hasOwnProperty("sector_bitmask1"))
            if (typeof message.sector_bitmask1 === "number")
              object.sector_bitmask1 = options.longs === String ? String(message.sector_bitmask1) : message.sector_bitmask1;
            else
              object.sector_bitmask1 = options.longs === String ? $util.Long.prototype.toString.call(message.sector_bitmask1) : options.longs === Number ? new $util.LongBits(message.sector_bitmask1.low >>> 0, message.sector_bitmask1.high >>> 0).toNumber(true) : message.sector_bitmask1;
          if (message.sector_bitmask2 != null && message.hasOwnProperty("sector_bitmask2"))
            if (typeof message.sector_bitmask2 === "number")
              object.sector_bitmask2 = options.longs === String ? String(message.sector_bitmask2) : message.sector_bitmask2;
            else
              object.sector_bitmask2 = options.longs === String ? $util.Long.prototype.toString.call(message.sector_bitmask2) : options.longs === Number ? new $util.LongBits(message.sector_bitmask2.low >>> 0, message.sector_bitmask2.high >>> 0).toNumber(true) : message.sector_bitmask2;
          if (message.ferti_bitmask1 != null && message.hasOwnProperty("ferti_bitmask1"))
            if (typeof message.ferti_bitmask1 === "number")
              object.ferti_bitmask1 = options.longs === String ? String(message.ferti_bitmask1) : message.ferti_bitmask1;
            else
              object.ferti_bitmask1 = options.longs === String ? $util.Long.prototype.toString.call(message.ferti_bitmask1) : options.longs === Number ? new $util.LongBits(message.ferti_bitmask1.low >>> 0, message.ferti_bitmask1.high >>> 0).toNumber(true) : message.ferti_bitmask1;
          if (message.ferti_bitmask2 != null && message.hasOwnProperty("ferti_bitmask2"))
            if (typeof message.ferti_bitmask2 === "number")
              object.ferti_bitmask2 = options.longs === String ? String(message.ferti_bitmask2) : message.ferti_bitmask2;
            else
              object.ferti_bitmask2 = options.longs === String ? $util.Long.prototype.toString.call(message.ferti_bitmask2) : options.longs === Number ? new $util.LongBits(message.ferti_bitmask2.low >>> 0, message.ferti_bitmask2.high >>> 0).toNumber(true) : message.ferti_bitmask2;
          if (message.waterpump != null && message.hasOwnProperty("waterpump"))
            object.waterpump = message.waterpump;
          if (message.backwash_time != null && message.hasOwnProperty("backwash_time"))
            if (typeof message.backwash_time === "number")
              object.backwash_time = options.longs === String ? String(message.backwash_time) : message.backwash_time;
            else
              object.backwash_time = options.longs === String ? $util.Long.prototype.toString.call(message.backwash_time) : options.longs === Number ? new $util.LongBits(message.backwash_time.low >>> 0, message.backwash_time.high >>> 0).toNumber(true) : message.backwash_time;
          if (message.number_of_sectors != null && message.hasOwnProperty("number_of_sectors"))
            object.number_of_sectors = message.number_of_sectors;
          if (message.had_waterpump != null && message.hasOwnProperty("had_waterpump"))
            object.had_waterpump = message.had_waterpump;
          if (message.had_ferti != null && message.hasOwnProperty("had_ferti"))
            object.had_ferti = message.had_ferti;
          if (message.time_of_resumption != null && message.hasOwnProperty("time_of_resumption"))
            if (typeof message.time_of_resumption === "number")
              object.time_of_resumption = options.longs === String ? String(message.time_of_resumption) : message.time_of_resumption;
            else
              object.time_of_resumption = options.longs === String ? $util.Long.prototype.toString.call(message.time_of_resumption) : options.longs === Number ? new $util.LongBits(message.time_of_resumption.low >>> 0, message.time_of_resumption.high >>> 0).toNumber(true) : message.time_of_resumption;
          if (message.resumption_attempts != null && message.hasOwnProperty("resumption_attempts"))
            object.resumption_attempts = message.resumption_attempts;
          if (message.status != null && message.hasOwnProperty("status"))
            object.status = message.status;
          return object;
        };
        SchedulingReportData.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        SchedulingReportData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.scheduling_report.SchedulingReportData";
        };
        return SchedulingReportData;
      }();
      scheduling_report.SchedulingReportPackage = function() {
        function SchedulingReportPackage(properties) {
          this.data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        SchedulingReportPackage.prototype.data = $util.emptyArray;
        SchedulingReportPackage.create = function create(properties) {
          return new SchedulingReportPackage(properties);
        };
        SchedulingReportPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.data != null && message.data.length)
            for (let i = 0;i < message.data.length; ++i)
              $root.codec.out.scheduling_report.SchedulingReportData.encode(message.data[i], writer.uint32(10).fork()).ldelim();
          return writer;
        };
        SchedulingReportPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        SchedulingReportPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.scheduling_report.SchedulingReportPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                if (!(message.data && message.data.length))
                  message.data = [];
                message.data.push($root.codec.out.scheduling_report.SchedulingReportData.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        SchedulingReportPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        SchedulingReportPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
              return "data: array expected";
            for (let i = 0;i < message.data.length; ++i) {
              let error = $root.codec.out.scheduling_report.SchedulingReportData.verify(message.data[i]);
              if (error)
                return "data." + error;
            }
          }
          return null;
        };
        SchedulingReportPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.scheduling_report.SchedulingReportPackage)
            return object;
          let message = new $root.codec.out.scheduling_report.SchedulingReportPackage;
          if (object.data) {
            if (!Array.isArray(object.data))
              throw TypeError(".codec.out.scheduling_report.SchedulingReportPackage.data: array expected");
            message.data = [];
            for (let i = 0;i < object.data.length; ++i) {
              if (typeof object.data[i] !== "object")
                throw TypeError(".codec.out.scheduling_report.SchedulingReportPackage.data: object expected");
              message.data[i] = $root.codec.out.scheduling_report.SchedulingReportData.fromObject(object.data[i]);
            }
          }
          return message;
        };
        SchedulingReportPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.data = [];
          if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0;j < message.data.length; ++j)
              object.data[j] = $root.codec.out.scheduling_report.SchedulingReportData.toObject(message.data[j], options);
          }
          return object;
        };
        SchedulingReportPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        SchedulingReportPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.scheduling_report.SchedulingReportPackage";
        };
        return SchedulingReportPackage;
      }();
      return scheduling_report;
    }();
    out.raw = function() {
      const raw = {};
      raw.RawPackage = function() {
        function RawPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        RawPackage.prototype.meshid = 0;
        RawPackage.prototype.equipment = 0;
        RawPackage.prototype.type = 0;
        RawPackage.prototype.payload = $util.newBuffer([]);
        RawPackage.create = function create(properties) {
          return new RawPackage(properties);
        };
        RawPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.meshid != null && Object.hasOwnProperty.call(message, "meshid"))
            writer.uint32(8).int32(message.meshid);
          if (message.equipment != null && Object.hasOwnProperty.call(message, "equipment"))
            writer.uint32(16).int32(message.equipment);
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(24).int32(message.type);
          if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(34).bytes(message.payload);
          return writer;
        };
        RawPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        RawPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.out.raw.RawPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.meshid = reader.int32();
                break;
              }
              case 2: {
                message.equipment = reader.int32();
                break;
              }
              case 3: {
                message.type = reader.int32();
                break;
              }
              case 4: {
                message.payload = reader.bytes();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        RawPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        RawPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.meshid != null && message.hasOwnProperty("meshid")) {
            if (!$util.isInteger(message.meshid))
              return "meshid: integer expected";
          }
          if (message.equipment != null && message.hasOwnProperty("equipment")) {
            if (!$util.isInteger(message.equipment))
              return "equipment: integer expected";
          }
          if (message.type != null && message.hasOwnProperty("type")) {
            if (!$util.isInteger(message.type))
              return "type: integer expected";
          }
          if (message.payload != null && message.hasOwnProperty("payload")) {
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
              return "payload: buffer expected";
          }
          return null;
        };
        RawPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.out.raw.RawPackage)
            return object;
          let message = new $root.codec.out.raw.RawPackage;
          if (object.meshid != null)
            message.meshid = object.meshid | 0;
          if (object.equipment != null)
            message.equipment = object.equipment | 0;
          if (object.type != null)
            message.type = object.type | 0;
          if (object.payload != null) {
            if (typeof object.payload === "string")
              $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
              message.payload = object.payload;
          }
          return message;
        };
        RawPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.meshid = 0;
            object.equipment = 0;
            object.type = 0;
            if (options.bytes === String)
              object.payload = "";
            else {
              object.payload = [];
              if (options.bytes !== Array)
                object.payload = $util.newBuffer(object.payload);
            }
          }
          if (message.meshid != null && message.hasOwnProperty("meshid"))
            object.meshid = message.meshid;
          if (message.equipment != null && message.hasOwnProperty("equipment"))
            object.equipment = message.equipment;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
          return object;
        };
        RawPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        RawPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.out.raw.RawPackage";
        };
        return RawPackage;
      }();
      return raw;
    }();
    return out;
  }();
  codec2.in_ = function() {
    const in_ = {};
    in_.automation = function() {
      const automation = {};
      automation.AutomationData = function() {
        function AutomationData(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AutomationData.prototype.level_idx = 0;
        AutomationData.prototype.pump_idx = 0;
        AutomationData.prototype.mask = 0;
        AutomationData.prototype.value = 0;
        AutomationData.prototype.working_time = 0;
        AutomationData.create = function create(properties) {
          return new AutomationData(properties);
        };
        AutomationData.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.level_idx != null && Object.hasOwnProperty.call(message, "level_idx"))
            writer.uint32(8).int32(message.level_idx);
          if (message.pump_idx != null && Object.hasOwnProperty.call(message, "pump_idx"))
            writer.uint32(16).int32(message.pump_idx);
          if (message.mask != null && Object.hasOwnProperty.call(message, "mask"))
            writer.uint32(24).int32(message.mask);
          if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(32).int32(message.value);
          if (message.working_time != null && Object.hasOwnProperty.call(message, "working_time"))
            writer.uint32(40).int32(message.working_time);
          return writer;
        };
        AutomationData.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AutomationData.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.automation.AutomationData;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.level_idx = reader.int32();
                break;
              }
              case 2: {
                message.pump_idx = reader.int32();
                break;
              }
              case 3: {
                message.mask = reader.int32();
                break;
              }
              case 4: {
                message.value = reader.int32();
                break;
              }
              case 5: {
                message.working_time = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AutomationData.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AutomationData.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.level_idx != null && message.hasOwnProperty("level_idx")) {
            if (!$util.isInteger(message.level_idx))
              return "level_idx: integer expected";
          }
          if (message.pump_idx != null && message.hasOwnProperty("pump_idx")) {
            if (!$util.isInteger(message.pump_idx))
              return "pump_idx: integer expected";
          }
          if (message.mask != null && message.hasOwnProperty("mask")) {
            if (!$util.isInteger(message.mask))
              return "mask: integer expected";
          }
          if (message.value != null && message.hasOwnProperty("value")) {
            if (!$util.isInteger(message.value))
              return "value: integer expected";
          }
          if (message.working_time != null && message.hasOwnProperty("working_time")) {
            if (!$util.isInteger(message.working_time))
              return "working_time: integer expected";
          }
          return null;
        };
        AutomationData.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.automation.AutomationData)
            return object;
          let message = new $root.codec.in_.automation.AutomationData;
          if (object.level_idx != null)
            message.level_idx = object.level_idx | 0;
          if (object.pump_idx != null)
            message.pump_idx = object.pump_idx | 0;
          if (object.mask != null)
            message.mask = object.mask | 0;
          if (object.value != null)
            message.value = object.value | 0;
          if (object.working_time != null)
            message.working_time = object.working_time | 0;
          return message;
        };
        AutomationData.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.level_idx = 0;
            object.pump_idx = 0;
            object.mask = 0;
            object.value = 0;
            object.working_time = 0;
          }
          if (message.level_idx != null && message.hasOwnProperty("level_idx"))
            object.level_idx = message.level_idx;
          if (message.pump_idx != null && message.hasOwnProperty("pump_idx"))
            object.pump_idx = message.pump_idx;
          if (message.mask != null && message.hasOwnProperty("mask"))
            object.mask = message.mask;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          if (message.working_time != null && message.hasOwnProperty("working_time"))
            object.working_time = message.working_time;
          return object;
        };
        AutomationData.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        AutomationData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.automation.AutomationData";
        };
        return AutomationData;
      }();
      automation.AutomationPackage = function() {
        function AutomationPackage(properties) {
          this.data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        AutomationPackage.prototype.data = $util.emptyArray;
        AutomationPackage.create = function create(properties) {
          return new AutomationPackage(properties);
        };
        AutomationPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.data != null && message.data.length)
            for (let i = 0;i < message.data.length; ++i)
              $root.codec.in_.automation.AutomationData.encode(message.data[i], writer.uint32(10).fork()).ldelim();
          return writer;
        };
        AutomationPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        AutomationPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.automation.AutomationPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                if (!(message.data && message.data.length))
                  message.data = [];
                message.data.push($root.codec.in_.automation.AutomationData.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        AutomationPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        AutomationPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
              return "data: array expected";
            for (let i = 0;i < message.data.length; ++i) {
              let error = $root.codec.in_.automation.AutomationData.verify(message.data[i]);
              if (error)
                return "data." + error;
            }
          }
          return null;
        };
        AutomationPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.automation.AutomationPackage)
            return object;
          let message = new $root.codec.in_.automation.AutomationPackage;
          if (object.data) {
            if (!Array.isArray(object.data))
              throw TypeError(".codec.in.automation.AutomationPackage.data: array expected");
            message.data = [];
            for (let i = 0;i < object.data.length; ++i) {
              if (typeof object.data[i] !== "object")
                throw TypeError(".codec.in.automation.AutomationPackage.data: object expected");
              message.data[i] = $root.codec.in_.automation.AutomationData.fromObject(object.data[i]);
            }
          }
          return message;
        };
        AutomationPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.data = [];
          if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0;j < message.data.length; ++j)
              object.data[j] = $root.codec.in_.automation.AutomationData.toObject(message.data[j], options);
          }
          return object;
        };
        AutomationPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        AutomationPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.automation.AutomationPackage";
        };
        return AutomationPackage;
      }();
      return automation;
    }();
    in_.command = function() {
      const command = {};
      command.CommandPackage = function() {
        function CommandPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        CommandPackage.prototype.type = 0;
        CommandPackage.prototype.value = 0;
        CommandPackage.create = function create(properties) {
          return new CommandPackage(properties);
        };
        CommandPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
          if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(16).int32(message.value);
          return writer;
        };
        CommandPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        CommandPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.command.CommandPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.type = reader.int32();
                break;
              }
              case 2: {
                message.value = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        CommandPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        CommandPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
              default:
                return "type: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.value != null && message.hasOwnProperty("value")) {
            if (!$util.isInteger(message.value))
              return "value: integer expected";
          }
          return null;
        };
        CommandPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.command.CommandPackage)
            return object;
          let message = new $root.codec.in_.command.CommandPackage;
          switch (object.type) {
            default:
              if (typeof object.type === "number") {
                message.type = object.type;
                break;
              }
              break;
            case "MSG_RESUME":
            case 0:
              message.type = 0;
              break;
            case "MSG_PAUSE":
            case 1:
              message.type = 1;
              break;
          }
          if (object.value != null)
            message.value = object.value | 0;
          return message;
        };
        CommandPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.type = options.enums === String ? "MSG_RESUME" : 0;
            object.value = 0;
          }
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.codec.in_.command.MsgType[message.type] === undefined ? message.type : $root.codec.in_.command.MsgType[message.type] : message.type;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          return object;
        };
        CommandPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        CommandPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.command.CommandPackage";
        };
        return CommandPackage;
      }();
      command.MsgType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MSG_RESUME"] = 0;
        values[valuesById[1] = "MSG_PAUSE"] = 1;
        return values;
      }();
      return command;
    }();
    in_.config = function() {
      const config = {};
      config.WifiConfig = function() {
        function WifiConfig(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        WifiConfig.prototype.ssid = "";
        WifiConfig.prototype.password = "";
        WifiConfig.create = function create(properties) {
          return new WifiConfig(properties);
        };
        WifiConfig.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.ssid != null && Object.hasOwnProperty.call(message, "ssid"))
            writer.uint32(10).string(message.ssid);
          if (message.password != null && Object.hasOwnProperty.call(message, "password"))
            writer.uint32(18).string(message.password);
          return writer;
        };
        WifiConfig.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        WifiConfig.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.config.WifiConfig;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.ssid = reader.string();
                break;
              }
              case 2: {
                message.password = reader.string();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        WifiConfig.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        WifiConfig.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.ssid != null && message.hasOwnProperty("ssid")) {
            if (!$util.isString(message.ssid))
              return "ssid: string expected";
          }
          if (message.password != null && message.hasOwnProperty("password")) {
            if (!$util.isString(message.password))
              return "password: string expected";
          }
          return null;
        };
        WifiConfig.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.config.WifiConfig)
            return object;
          let message = new $root.codec.in_.config.WifiConfig;
          if (object.ssid != null)
            message.ssid = String(object.ssid);
          if (object.password != null)
            message.password = String(object.password);
          return message;
        };
        WifiConfig.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.ssid = "";
            object.password = "";
          }
          if (message.ssid != null && message.hasOwnProperty("ssid"))
            object.ssid = message.ssid;
          if (message.password != null && message.hasOwnProperty("password"))
            object.password = message.password;
          return object;
        };
        WifiConfig.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        WifiConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.config.WifiConfig";
        };
        return WifiConfig;
      }();
      config.MeshConfig = function() {
        function MeshConfig(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        MeshConfig.prototype.key = $util.newBuffer([]);
        MeshConfig.prototype.channel = 0;
        MeshConfig.create = function create(properties) {
          return new MeshConfig(properties);
        };
        MeshConfig.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(10).bytes(message.key);
          if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(16).uint32(message.channel);
          return writer;
        };
        MeshConfig.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        MeshConfig.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.config.MeshConfig;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.key = reader.bytes();
                break;
              }
              case 2: {
                message.channel = reader.uint32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        MeshConfig.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        MeshConfig.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.key != null && message.hasOwnProperty("key")) {
            if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
              return "key: buffer expected";
          }
          if (message.channel != null && message.hasOwnProperty("channel")) {
            if (!$util.isInteger(message.channel))
              return "channel: integer expected";
          }
          return null;
        };
        MeshConfig.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.config.MeshConfig)
            return object;
          let message = new $root.codec.in_.config.MeshConfig;
          if (object.key != null) {
            if (typeof object.key === "string")
              $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
            else if (object.key.length >= 0)
              message.key = object.key;
          }
          if (object.channel != null)
            message.channel = object.channel >>> 0;
          return message;
        };
        MeshConfig.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            if (options.bytes === String)
              object.key = "";
            else {
              object.key = [];
              if (options.bytes !== Array)
                object.key = $util.newBuffer(object.key);
            }
            object.channel = 0;
          }
          if (message.key != null && message.hasOwnProperty("key"))
            object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
          if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
          return object;
        };
        MeshConfig.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        MeshConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.config.MeshConfig";
        };
        return MeshConfig;
      }();
      config.PublishRawFlag = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PUBLISH_RAW_NONE"] = 0;
        values[valuesById[1] = "PUBLISH_RAW_DEV_OTHERS"] = 1;
        values[valuesById[2] = "PUBLISH_RAW_DEV_STATUS"] = 2;
        values[valuesById[4] = "PUBLISH_RAW_DEV_CONFIG"] = 4;
        values[valuesById[8] = "PUBLISH_RAW_DEV_RESET"] = 8;
        return values;
      }();
      config.ConfigPackage = function() {
        function ConfigPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        ConfigPackage.prototype.backwash_cycle = 0;
        ConfigPackage.prototype.backwash_duration = 0;
        ConfigPackage.prototype.backwash_delay = 0;
        ConfigPackage.prototype.raingauge_enabled = false;
        ConfigPackage.prototype.raingauge_factor = 0;
        ConfigPackage.prototype.rainfall_limit = 0;
        ConfigPackage.prototype.rainfall_pause_duration = 0;
        ConfigPackage.prototype.wifi = null;
        ConfigPackage.prototype.mesh = null;
        ConfigPackage.prototype.publish_raw_data = 0;
        ConfigPackage.prototype.debug = false;
        ConfigPackage.prototype.enable_schedule_resumption = false;
        ConfigPackage.prototype.enable_ferti_resumption = false;
        ConfigPackage.prototype.max_resumption_attempts = 0;
        ConfigPackage.prototype.wdt_mqtt = false;
        ConfigPackage.create = function create(properties) {
          return new ConfigPackage(properties);
        };
        ConfigPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.backwash_cycle != null && Object.hasOwnProperty.call(message, "backwash_cycle"))
            writer.uint32(8).int32(message.backwash_cycle);
          if (message.backwash_duration != null && Object.hasOwnProperty.call(message, "backwash_duration"))
            writer.uint32(16).int32(message.backwash_duration);
          if (message.backwash_delay != null && Object.hasOwnProperty.call(message, "backwash_delay"))
            writer.uint32(24).int32(message.backwash_delay);
          if (message.raingauge_enabled != null && Object.hasOwnProperty.call(message, "raingauge_enabled"))
            writer.uint32(32).bool(message.raingauge_enabled);
          if (message.raingauge_factor != null && Object.hasOwnProperty.call(message, "raingauge_factor"))
            writer.uint32(40).int32(message.raingauge_factor);
          if (message.rainfall_limit != null && Object.hasOwnProperty.call(message, "rainfall_limit"))
            writer.uint32(48).int32(message.rainfall_limit);
          if (message.rainfall_pause_duration != null && Object.hasOwnProperty.call(message, "rainfall_pause_duration"))
            writer.uint32(56).int32(message.rainfall_pause_duration);
          if (message.wifi != null && Object.hasOwnProperty.call(message, "wifi"))
            $root.codec.in_.config.WifiConfig.encode(message.wifi, writer.uint32(66).fork()).ldelim();
          if (message.mesh != null && Object.hasOwnProperty.call(message, "mesh"))
            $root.codec.in_.config.MeshConfig.encode(message.mesh, writer.uint32(74).fork()).ldelim();
          if (message.publish_raw_data != null && Object.hasOwnProperty.call(message, "publish_raw_data"))
            writer.uint32(80).int32(message.publish_raw_data);
          if (message.debug != null && Object.hasOwnProperty.call(message, "debug"))
            writer.uint32(88).bool(message.debug);
          if (message.enable_schedule_resumption != null && Object.hasOwnProperty.call(message, "enable_schedule_resumption"))
            writer.uint32(96).bool(message.enable_schedule_resumption);
          if (message.enable_ferti_resumption != null && Object.hasOwnProperty.call(message, "enable_ferti_resumption"))
            writer.uint32(104).bool(message.enable_ferti_resumption);
          if (message.max_resumption_attempts != null && Object.hasOwnProperty.call(message, "max_resumption_attempts"))
            writer.uint32(112).int32(message.max_resumption_attempts);
          if (message.wdt_mqtt != null && Object.hasOwnProperty.call(message, "wdt_mqtt"))
            writer.uint32(120).bool(message.wdt_mqtt);
          return writer;
        };
        ConfigPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        ConfigPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.config.ConfigPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.backwash_cycle = reader.int32();
                break;
              }
              case 2: {
                message.backwash_duration = reader.int32();
                break;
              }
              case 3: {
                message.backwash_delay = reader.int32();
                break;
              }
              case 4: {
                message.raingauge_enabled = reader.bool();
                break;
              }
              case 5: {
                message.raingauge_factor = reader.int32();
                break;
              }
              case 6: {
                message.rainfall_limit = reader.int32();
                break;
              }
              case 7: {
                message.rainfall_pause_duration = reader.int32();
                break;
              }
              case 8: {
                message.wifi = $root.codec.in_.config.WifiConfig.decode(reader, reader.uint32());
                break;
              }
              case 9: {
                message.mesh = $root.codec.in_.config.MeshConfig.decode(reader, reader.uint32());
                break;
              }
              case 10: {
                message.publish_raw_data = reader.int32();
                break;
              }
              case 11: {
                message.debug = reader.bool();
                break;
              }
              case 12: {
                message.enable_schedule_resumption = reader.bool();
                break;
              }
              case 13: {
                message.enable_ferti_resumption = reader.bool();
                break;
              }
              case 14: {
                message.max_resumption_attempts = reader.int32();
                break;
              }
              case 15: {
                message.wdt_mqtt = reader.bool();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        ConfigPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        ConfigPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.backwash_cycle != null && message.hasOwnProperty("backwash_cycle")) {
            if (!$util.isInteger(message.backwash_cycle))
              return "backwash_cycle: integer expected";
          }
          if (message.backwash_duration != null && message.hasOwnProperty("backwash_duration")) {
            if (!$util.isInteger(message.backwash_duration))
              return "backwash_duration: integer expected";
          }
          if (message.backwash_delay != null && message.hasOwnProperty("backwash_delay")) {
            if (!$util.isInteger(message.backwash_delay))
              return "backwash_delay: integer expected";
          }
          if (message.raingauge_enabled != null && message.hasOwnProperty("raingauge_enabled")) {
            if (typeof message.raingauge_enabled !== "boolean")
              return "raingauge_enabled: boolean expected";
          }
          if (message.raingauge_factor != null && message.hasOwnProperty("raingauge_factor")) {
            if (!$util.isInteger(message.raingauge_factor))
              return "raingauge_factor: integer expected";
          }
          if (message.rainfall_limit != null && message.hasOwnProperty("rainfall_limit")) {
            if (!$util.isInteger(message.rainfall_limit))
              return "rainfall_limit: integer expected";
          }
          if (message.rainfall_pause_duration != null && message.hasOwnProperty("rainfall_pause_duration")) {
            if (!$util.isInteger(message.rainfall_pause_duration))
              return "rainfall_pause_duration: integer expected";
          }
          if (message.wifi != null && message.hasOwnProperty("wifi")) {
            let error = $root.codec.in_.config.WifiConfig.verify(message.wifi);
            if (error)
              return "wifi." + error;
          }
          if (message.mesh != null && message.hasOwnProperty("mesh")) {
            let error = $root.codec.in_.config.MeshConfig.verify(message.mesh);
            if (error)
              return "mesh." + error;
          }
          if (message.publish_raw_data != null && message.hasOwnProperty("publish_raw_data")) {
            if (!$util.isInteger(message.publish_raw_data))
              return "publish_raw_data: integer expected";
          }
          if (message.debug != null && message.hasOwnProperty("debug")) {
            if (typeof message.debug !== "boolean")
              return "debug: boolean expected";
          }
          if (message.enable_schedule_resumption != null && message.hasOwnProperty("enable_schedule_resumption")) {
            if (typeof message.enable_schedule_resumption !== "boolean")
              return "enable_schedule_resumption: boolean expected";
          }
          if (message.enable_ferti_resumption != null && message.hasOwnProperty("enable_ferti_resumption")) {
            if (typeof message.enable_ferti_resumption !== "boolean")
              return "enable_ferti_resumption: boolean expected";
          }
          if (message.max_resumption_attempts != null && message.hasOwnProperty("max_resumption_attempts")) {
            if (!$util.isInteger(message.max_resumption_attempts))
              return "max_resumption_attempts: integer expected";
          }
          if (message.wdt_mqtt != null && message.hasOwnProperty("wdt_mqtt")) {
            if (typeof message.wdt_mqtt !== "boolean")
              return "wdt_mqtt: boolean expected";
          }
          return null;
        };
        ConfigPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.config.ConfigPackage)
            return object;
          let message = new $root.codec.in_.config.ConfigPackage;
          if (object.backwash_cycle != null)
            message.backwash_cycle = object.backwash_cycle | 0;
          if (object.backwash_duration != null)
            message.backwash_duration = object.backwash_duration | 0;
          if (object.backwash_delay != null)
            message.backwash_delay = object.backwash_delay | 0;
          if (object.raingauge_enabled != null)
            message.raingauge_enabled = Boolean(object.raingauge_enabled);
          if (object.raingauge_factor != null)
            message.raingauge_factor = object.raingauge_factor | 0;
          if (object.rainfall_limit != null)
            message.rainfall_limit = object.rainfall_limit | 0;
          if (object.rainfall_pause_duration != null)
            message.rainfall_pause_duration = object.rainfall_pause_duration | 0;
          if (object.wifi != null) {
            if (typeof object.wifi !== "object")
              throw TypeError(".codec.in.config.ConfigPackage.wifi: object expected");
            message.wifi = $root.codec.in_.config.WifiConfig.fromObject(object.wifi);
          }
          if (object.mesh != null) {
            if (typeof object.mesh !== "object")
              throw TypeError(".codec.in.config.ConfigPackage.mesh: object expected");
            message.mesh = $root.codec.in_.config.MeshConfig.fromObject(object.mesh);
          }
          if (object.publish_raw_data != null)
            message.publish_raw_data = object.publish_raw_data | 0;
          if (object.debug != null)
            message.debug = Boolean(object.debug);
          if (object.enable_schedule_resumption != null)
            message.enable_schedule_resumption = Boolean(object.enable_schedule_resumption);
          if (object.enable_ferti_resumption != null)
            message.enable_ferti_resumption = Boolean(object.enable_ferti_resumption);
          if (object.max_resumption_attempts != null)
            message.max_resumption_attempts = object.max_resumption_attempts | 0;
          if (object.wdt_mqtt != null)
            message.wdt_mqtt = Boolean(object.wdt_mqtt);
          return message;
        };
        ConfigPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.backwash_cycle = 0;
            object.backwash_duration = 0;
            object.backwash_delay = 0;
            object.raingauge_enabled = false;
            object.raingauge_factor = 0;
            object.rainfall_limit = 0;
            object.rainfall_pause_duration = 0;
            object.wifi = null;
            object.mesh = null;
            object.publish_raw_data = 0;
            object.debug = false;
            object.enable_schedule_resumption = false;
            object.enable_ferti_resumption = false;
            object.max_resumption_attempts = 0;
            object.wdt_mqtt = false;
          }
          if (message.backwash_cycle != null && message.hasOwnProperty("backwash_cycle"))
            object.backwash_cycle = message.backwash_cycle;
          if (message.backwash_duration != null && message.hasOwnProperty("backwash_duration"))
            object.backwash_duration = message.backwash_duration;
          if (message.backwash_delay != null && message.hasOwnProperty("backwash_delay"))
            object.backwash_delay = message.backwash_delay;
          if (message.raingauge_enabled != null && message.hasOwnProperty("raingauge_enabled"))
            object.raingauge_enabled = message.raingauge_enabled;
          if (message.raingauge_factor != null && message.hasOwnProperty("raingauge_factor"))
            object.raingauge_factor = message.raingauge_factor;
          if (message.rainfall_limit != null && message.hasOwnProperty("rainfall_limit"))
            object.rainfall_limit = message.rainfall_limit;
          if (message.rainfall_pause_duration != null && message.hasOwnProperty("rainfall_pause_duration"))
            object.rainfall_pause_duration = message.rainfall_pause_duration;
          if (message.wifi != null && message.hasOwnProperty("wifi"))
            object.wifi = $root.codec.in_.config.WifiConfig.toObject(message.wifi, options);
          if (message.mesh != null && message.hasOwnProperty("mesh"))
            object.mesh = $root.codec.in_.config.MeshConfig.toObject(message.mesh, options);
          if (message.publish_raw_data != null && message.hasOwnProperty("publish_raw_data"))
            object.publish_raw_data = message.publish_raw_data;
          if (message.debug != null && message.hasOwnProperty("debug"))
            object.debug = message.debug;
          if (message.enable_schedule_resumption != null && message.hasOwnProperty("enable_schedule_resumption"))
            object.enable_schedule_resumption = message.enable_schedule_resumption;
          if (message.enable_ferti_resumption != null && message.hasOwnProperty("enable_ferti_resumption"))
            object.enable_ferti_resumption = message.enable_ferti_resumption;
          if (message.max_resumption_attempts != null && message.hasOwnProperty("max_resumption_attempts"))
            object.max_resumption_attempts = message.max_resumption_attempts;
          if (message.wdt_mqtt != null && message.hasOwnProperty("wdt_mqtt"))
            object.wdt_mqtt = message.wdt_mqtt;
          return object;
        };
        ConfigPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        ConfigPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.config.ConfigPackage";
        };
        return ConfigPackage;
      }();
      return config;
    }();
    in_.control = function() {
      const control = {};
      control.ControlPackage = function() {
        function ControlPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        ControlPackage.prototype.idx = 0;
        ControlPackage.prototype.action = 0;
        ControlPackage.prototype.value = 0;
        ControlPackage.prototype.payload = $util.newBuffer([]);
        ControlPackage.prototype.activation_code = 0;
        ControlPackage.create = function create(properties) {
          return new ControlPackage(properties);
        };
        ControlPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
            writer.uint32(8).int32(message.idx);
          if (message.action != null && Object.hasOwnProperty.call(message, "action"))
            writer.uint32(16).int32(message.action);
          if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(24).int32(message.value);
          if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(34).bytes(message.payload);
          if (message.activation_code != null && Object.hasOwnProperty.call(message, "activation_code"))
            writer.uint32(40).int32(message.activation_code);
          return writer;
        };
        ControlPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        ControlPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.control.ControlPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.idx = reader.int32();
                break;
              }
              case 2: {
                message.action = reader.int32();
                break;
              }
              case 3: {
                message.value = reader.int32();
                break;
              }
              case 4: {
                message.payload = reader.bytes();
                break;
              }
              case 5: {
                message.activation_code = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        ControlPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        ControlPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.idx != null && message.hasOwnProperty("idx")) {
            if (!$util.isInteger(message.idx))
              return "idx: integer expected";
          }
          if (message.action != null && message.hasOwnProperty("action"))
            switch (message.action) {
              default:
                return "action: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.value != null && message.hasOwnProperty("value")) {
            if (!$util.isInteger(message.value))
              return "value: integer expected";
          }
          if (message.payload != null && message.hasOwnProperty("payload")) {
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
              return "payload: buffer expected";
          }
          if (message.activation_code != null && message.hasOwnProperty("activation_code")) {
            if (!$util.isInteger(message.activation_code))
              return "activation_code: integer expected";
          }
          return null;
        };
        ControlPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.control.ControlPackage)
            return object;
          let message = new $root.codec.in_.control.ControlPackage;
          if (object.idx != null)
            message.idx = object.idx | 0;
          switch (object.action) {
            default:
              if (typeof object.action === "number") {
                message.action = object.action;
                break;
              }
              break;
            case "MSG_NONE":
            case 0:
              message.action = 0;
              break;
            case "MSG_TURN_ON":
            case 1:
              message.action = 1;
              break;
            case "MSG_TURN_OFF":
            case 2:
              message.action = 2;
              break;
            case "MSG_PACKAGE":
            case 3:
              message.action = 3;
              break;
          }
          if (object.value != null)
            message.value = object.value | 0;
          if (object.payload != null) {
            if (typeof object.payload === "string")
              $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
              message.payload = object.payload;
          }
          if (object.activation_code != null)
            message.activation_code = object.activation_code | 0;
          return message;
        };
        ControlPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.idx = 0;
            object.action = options.enums === String ? "MSG_NONE" : 0;
            object.value = 0;
            if (options.bytes === String)
              object.payload = "";
            else {
              object.payload = [];
              if (options.bytes !== Array)
                object.payload = $util.newBuffer(object.payload);
            }
            object.activation_code = 0;
          }
          if (message.idx != null && message.hasOwnProperty("idx"))
            object.idx = message.idx;
          if (message.action != null && message.hasOwnProperty("action"))
            object.action = options.enums === String ? $root.codec.in_.control.MsgAction[message.action] === undefined ? message.action : $root.codec.in_.control.MsgAction[message.action] : message.action;
          if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
          if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
          if (message.activation_code != null && message.hasOwnProperty("activation_code"))
            object.activation_code = message.activation_code;
          return object;
        };
        ControlPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        ControlPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.control.ControlPackage";
        };
        return ControlPackage;
      }();
      control.MsgAction = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MSG_NONE"] = 0;
        values[valuesById[1] = "MSG_TURN_ON"] = 1;
        values[valuesById[2] = "MSG_TURN_OFF"] = 2;
        values[valuesById[3] = "MSG_PACKAGE"] = 3;
        return values;
      }();
      return control;
    }();
    in_.device_scheduling = function() {
      const device_scheduling = {};
      device_scheduling.DeviceScheduling = function() {
        function DeviceScheduling(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DeviceScheduling.prototype.idx = 0;
        DeviceScheduling.prototype.scheduling_idx = 0;
        DeviceScheduling.prototype.device_idx = 0;
        DeviceScheduling.prototype.order = 0;
        DeviceScheduling.prototype.sector_working_time = 0;
        DeviceScheduling.prototype.ferti_working_time = 0;
        DeviceScheduling.prototype.ferti_delay = 0;
        DeviceScheduling.create = function create(properties) {
          return new DeviceScheduling(properties);
        };
        DeviceScheduling.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
            writer.uint32(8).int32(message.idx);
          if (message.scheduling_idx != null && Object.hasOwnProperty.call(message, "scheduling_idx"))
            writer.uint32(16).int32(message.scheduling_idx);
          if (message.device_idx != null && Object.hasOwnProperty.call(message, "device_idx"))
            writer.uint32(24).int32(message.device_idx);
          if (message.order != null && Object.hasOwnProperty.call(message, "order"))
            writer.uint32(32).int32(message.order);
          if (message.sector_working_time != null && Object.hasOwnProperty.call(message, "sector_working_time"))
            writer.uint32(40).int32(message.sector_working_time);
          if (message.ferti_working_time != null && Object.hasOwnProperty.call(message, "ferti_working_time"))
            writer.uint32(48).int32(message.ferti_working_time);
          if (message.ferti_delay != null && Object.hasOwnProperty.call(message, "ferti_delay"))
            writer.uint32(56).int32(message.ferti_delay);
          return writer;
        };
        DeviceScheduling.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DeviceScheduling.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.device_scheduling.DeviceScheduling;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.idx = reader.int32();
                break;
              }
              case 2: {
                message.scheduling_idx = reader.int32();
                break;
              }
              case 3: {
                message.device_idx = reader.int32();
                break;
              }
              case 4: {
                message.order = reader.int32();
                break;
              }
              case 5: {
                message.sector_working_time = reader.int32();
                break;
              }
              case 6: {
                message.ferti_working_time = reader.int32();
                break;
              }
              case 7: {
                message.ferti_delay = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DeviceScheduling.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DeviceScheduling.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.idx != null && message.hasOwnProperty("idx")) {
            if (!$util.isInteger(message.idx))
              return "idx: integer expected";
          }
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx")) {
            if (!$util.isInteger(message.scheduling_idx))
              return "scheduling_idx: integer expected";
          }
          if (message.device_idx != null && message.hasOwnProperty("device_idx")) {
            if (!$util.isInteger(message.device_idx))
              return "device_idx: integer expected";
          }
          if (message.order != null && message.hasOwnProperty("order")) {
            if (!$util.isInteger(message.order))
              return "order: integer expected";
          }
          if (message.sector_working_time != null && message.hasOwnProperty("sector_working_time")) {
            if (!$util.isInteger(message.sector_working_time))
              return "sector_working_time: integer expected";
          }
          if (message.ferti_working_time != null && message.hasOwnProperty("ferti_working_time")) {
            if (!$util.isInteger(message.ferti_working_time))
              return "ferti_working_time: integer expected";
          }
          if (message.ferti_delay != null && message.hasOwnProperty("ferti_delay")) {
            if (!$util.isInteger(message.ferti_delay))
              return "ferti_delay: integer expected";
          }
          return null;
        };
        DeviceScheduling.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.device_scheduling.DeviceScheduling)
            return object;
          let message = new $root.codec.in_.device_scheduling.DeviceScheduling;
          if (object.idx != null)
            message.idx = object.idx | 0;
          if (object.scheduling_idx != null)
            message.scheduling_idx = object.scheduling_idx | 0;
          if (object.device_idx != null)
            message.device_idx = object.device_idx | 0;
          if (object.order != null)
            message.order = object.order | 0;
          if (object.sector_working_time != null)
            message.sector_working_time = object.sector_working_time | 0;
          if (object.ferti_working_time != null)
            message.ferti_working_time = object.ferti_working_time | 0;
          if (object.ferti_delay != null)
            message.ferti_delay = object.ferti_delay | 0;
          return message;
        };
        DeviceScheduling.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.idx = 0;
            object.scheduling_idx = 0;
            object.device_idx = 0;
            object.order = 0;
            object.sector_working_time = 0;
            object.ferti_working_time = 0;
            object.ferti_delay = 0;
          }
          if (message.idx != null && message.hasOwnProperty("idx"))
            object.idx = message.idx;
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx"))
            object.scheduling_idx = message.scheduling_idx;
          if (message.device_idx != null && message.hasOwnProperty("device_idx"))
            object.device_idx = message.device_idx;
          if (message.order != null && message.hasOwnProperty("order"))
            object.order = message.order;
          if (message.sector_working_time != null && message.hasOwnProperty("sector_working_time"))
            object.sector_working_time = message.sector_working_time;
          if (message.ferti_working_time != null && message.hasOwnProperty("ferti_working_time"))
            object.ferti_working_time = message.ferti_working_time;
          if (message.ferti_delay != null && message.hasOwnProperty("ferti_delay"))
            object.ferti_delay = message.ferti_delay;
          return object;
        };
        DeviceScheduling.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        DeviceScheduling.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.device_scheduling.DeviceScheduling";
        };
        return DeviceScheduling;
      }();
      device_scheduling.DeviceSchedulingPackage = function() {
        function DeviceSchedulingPackage(properties) {
          this.data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DeviceSchedulingPackage.prototype.data = $util.emptyArray;
        DeviceSchedulingPackage.create = function create(properties) {
          return new DeviceSchedulingPackage(properties);
        };
        DeviceSchedulingPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.data != null && message.data.length)
            for (let i = 0;i < message.data.length; ++i)
              $root.codec.in_.device_scheduling.DeviceScheduling.encode(message.data[i], writer.uint32(10).fork()).ldelim();
          return writer;
        };
        DeviceSchedulingPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DeviceSchedulingPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.device_scheduling.DeviceSchedulingPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                if (!(message.data && message.data.length))
                  message.data = [];
                message.data.push($root.codec.in_.device_scheduling.DeviceScheduling.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DeviceSchedulingPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DeviceSchedulingPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
              return "data: array expected";
            for (let i = 0;i < message.data.length; ++i) {
              let error = $root.codec.in_.device_scheduling.DeviceScheduling.verify(message.data[i]);
              if (error)
                return "data." + error;
            }
          }
          return null;
        };
        DeviceSchedulingPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.device_scheduling.DeviceSchedulingPackage)
            return object;
          let message = new $root.codec.in_.device_scheduling.DeviceSchedulingPackage;
          if (object.data) {
            if (!Array.isArray(object.data))
              throw TypeError(".codec.in.device_scheduling.DeviceSchedulingPackage.data: array expected");
            message.data = [];
            for (let i = 0;i < object.data.length; ++i) {
              if (typeof object.data[i] !== "object")
                throw TypeError(".codec.in.device_scheduling.DeviceSchedulingPackage.data: object expected");
              message.data[i] = $root.codec.in_.device_scheduling.DeviceScheduling.fromObject(object.data[i]);
            }
          }
          return message;
        };
        DeviceSchedulingPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.data = [];
          if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0;j < message.data.length; ++j)
              object.data[j] = $root.codec.in_.device_scheduling.DeviceScheduling.toObject(message.data[j], options);
          }
          return object;
        };
        DeviceSchedulingPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        DeviceSchedulingPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.device_scheduling.DeviceSchedulingPackage";
        };
        return DeviceSchedulingPackage;
      }();
      return device_scheduling;
    }();
    in_.devices = function() {
      const devices = {};
      devices.DevicesData = function() {
        function DevicesData(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DevicesData.prototype.idx = 0;
        DevicesData.prototype.mesh_id = 0;
        DevicesData.prototype.device_id = 0;
        DevicesData.prototype.device_type = 0;
        DevicesData.prototype.out1 = 0;
        DevicesData.prototype.out2 = 0;
        DevicesData.prototype.input = 0;
        DevicesData.prototype.mode = 0;
        DevicesData.prototype.sector = 0;
        DevicesData.prototype.group_idx = 0;
        DevicesData.prototype.power = 0;
        DevicesData.prototype.equipment = 0;
        DevicesData.create = function create(properties) {
          return new DevicesData(properties);
        };
        DevicesData.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
            writer.uint32(8).int32(message.idx);
          if (message.mesh_id != null && Object.hasOwnProperty.call(message, "mesh_id"))
            writer.uint32(16).int32(message.mesh_id);
          if (message.device_id != null && Object.hasOwnProperty.call(message, "device_id"))
            writer.uint32(24).int32(message.device_id);
          if (message.device_type != null && Object.hasOwnProperty.call(message, "device_type"))
            writer.uint32(32).int32(message.device_type);
          if (message.out1 != null && Object.hasOwnProperty.call(message, "out1"))
            writer.uint32(40).int32(message.out1);
          if (message.out2 != null && Object.hasOwnProperty.call(message, "out2"))
            writer.uint32(48).int32(message.out2);
          if (message.input != null && Object.hasOwnProperty.call(message, "input"))
            writer.uint32(56).int32(message.input);
          if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
            writer.uint32(64).int32(message.mode);
          if (message.sector != null && Object.hasOwnProperty.call(message, "sector"))
            writer.uint32(72).int32(message.sector);
          if (message.group_idx != null && Object.hasOwnProperty.call(message, "group_idx"))
            writer.uint32(80).int32(message.group_idx);
          if (message.power != null && Object.hasOwnProperty.call(message, "power"))
            writer.uint32(88).int32(message.power);
          if (message.equipment != null && Object.hasOwnProperty.call(message, "equipment"))
            writer.uint32(96).int32(message.equipment);
          return writer;
        };
        DevicesData.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DevicesData.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.devices.DevicesData;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.idx = reader.int32();
                break;
              }
              case 2: {
                message.mesh_id = reader.int32();
                break;
              }
              case 3: {
                message.device_id = reader.int32();
                break;
              }
              case 4: {
                message.device_type = reader.int32();
                break;
              }
              case 5: {
                message.out1 = reader.int32();
                break;
              }
              case 6: {
                message.out2 = reader.int32();
                break;
              }
              case 7: {
                message.input = reader.int32();
                break;
              }
              case 8: {
                message.mode = reader.int32();
                break;
              }
              case 9: {
                message.sector = reader.int32();
                break;
              }
              case 10: {
                message.group_idx = reader.int32();
                break;
              }
              case 11: {
                message.power = reader.int32();
                break;
              }
              case 12: {
                message.equipment = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DevicesData.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DevicesData.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.idx != null && message.hasOwnProperty("idx")) {
            if (!$util.isInteger(message.idx))
              return "idx: integer expected";
          }
          if (message.mesh_id != null && message.hasOwnProperty("mesh_id")) {
            if (!$util.isInteger(message.mesh_id))
              return "mesh_id: integer expected";
          }
          if (message.device_id != null && message.hasOwnProperty("device_id")) {
            if (!$util.isInteger(message.device_id))
              return "device_id: integer expected";
          }
          if (message.device_type != null && message.hasOwnProperty("device_type")) {
            if (!$util.isInteger(message.device_type))
              return "device_type: integer expected";
          }
          if (message.out1 != null && message.hasOwnProperty("out1")) {
            if (!$util.isInteger(message.out1))
              return "out1: integer expected";
          }
          if (message.out2 != null && message.hasOwnProperty("out2")) {
            if (!$util.isInteger(message.out2))
              return "out2: integer expected";
          }
          if (message.input != null && message.hasOwnProperty("input")) {
            if (!$util.isInteger(message.input))
              return "input: integer expected";
          }
          if (message.mode != null && message.hasOwnProperty("mode")) {
            if (!$util.isInteger(message.mode))
              return "mode: integer expected";
          }
          if (message.sector != null && message.hasOwnProperty("sector")) {
            if (!$util.isInteger(message.sector))
              return "sector: integer expected";
          }
          if (message.group_idx != null && message.hasOwnProperty("group_idx")) {
            if (!$util.isInteger(message.group_idx))
              return "group_idx: integer expected";
          }
          if (message.power != null && message.hasOwnProperty("power")) {
            if (!$util.isInteger(message.power))
              return "power: integer expected";
          }
          if (message.equipment != null && message.hasOwnProperty("equipment")) {
            if (!$util.isInteger(message.equipment))
              return "equipment: integer expected";
          }
          return null;
        };
        DevicesData.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.devices.DevicesData)
            return object;
          let message = new $root.codec.in_.devices.DevicesData;
          if (object.idx != null)
            message.idx = object.idx | 0;
          if (object.mesh_id != null)
            message.mesh_id = object.mesh_id | 0;
          if (object.device_id != null)
            message.device_id = object.device_id | 0;
          if (object.device_type != null)
            message.device_type = object.device_type | 0;
          if (object.out1 != null)
            message.out1 = object.out1 | 0;
          if (object.out2 != null)
            message.out2 = object.out2 | 0;
          if (object.input != null)
            message.input = object.input | 0;
          if (object.mode != null)
            message.mode = object.mode | 0;
          if (object.sector != null)
            message.sector = object.sector | 0;
          if (object.group_idx != null)
            message.group_idx = object.group_idx | 0;
          if (object.power != null)
            message.power = object.power | 0;
          if (object.equipment != null)
            message.equipment = object.equipment | 0;
          return message;
        };
        DevicesData.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.idx = 0;
            object.mesh_id = 0;
            object.device_id = 0;
            object.device_type = 0;
            object.out1 = 0;
            object.out2 = 0;
            object.input = 0;
            object.mode = 0;
            object.sector = 0;
            object.group_idx = 0;
            object.power = 0;
            object.equipment = 0;
          }
          if (message.idx != null && message.hasOwnProperty("idx"))
            object.idx = message.idx;
          if (message.mesh_id != null && message.hasOwnProperty("mesh_id"))
            object.mesh_id = message.mesh_id;
          if (message.device_id != null && message.hasOwnProperty("device_id"))
            object.device_id = message.device_id;
          if (message.device_type != null && message.hasOwnProperty("device_type"))
            object.device_type = message.device_type;
          if (message.out1 != null && message.hasOwnProperty("out1"))
            object.out1 = message.out1;
          if (message.out2 != null && message.hasOwnProperty("out2"))
            object.out2 = message.out2;
          if (message.input != null && message.hasOwnProperty("input"))
            object.input = message.input;
          if (message.mode != null && message.hasOwnProperty("mode"))
            object.mode = message.mode;
          if (message.sector != null && message.hasOwnProperty("sector"))
            object.sector = message.sector;
          if (message.group_idx != null && message.hasOwnProperty("group_idx"))
            object.group_idx = message.group_idx;
          if (message.power != null && message.hasOwnProperty("power"))
            object.power = message.power;
          if (message.equipment != null && message.hasOwnProperty("equipment"))
            object.equipment = message.equipment;
          return object;
        };
        DevicesData.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        DevicesData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.devices.DevicesData";
        };
        return DevicesData;
      }();
      devices.DevicesPackage = function() {
        function DevicesPackage(properties) {
          this.data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DevicesPackage.prototype.data = $util.emptyArray;
        DevicesPackage.create = function create(properties) {
          return new DevicesPackage(properties);
        };
        DevicesPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.data != null && message.data.length)
            for (let i = 0;i < message.data.length; ++i)
              $root.codec.in_.devices.DevicesData.encode(message.data[i], writer.uint32(10).fork()).ldelim();
          return writer;
        };
        DevicesPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DevicesPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.devices.DevicesPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                if (!(message.data && message.data.length))
                  message.data = [];
                message.data.push($root.codec.in_.devices.DevicesData.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DevicesPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DevicesPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.data != null && message.hasOwnProperty("data")) {
            if (!Array.isArray(message.data))
              return "data: array expected";
            for (let i = 0;i < message.data.length; ++i) {
              let error = $root.codec.in_.devices.DevicesData.verify(message.data[i]);
              if (error)
                return "data." + error;
            }
          }
          return null;
        };
        DevicesPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.devices.DevicesPackage)
            return object;
          let message = new $root.codec.in_.devices.DevicesPackage;
          if (object.data) {
            if (!Array.isArray(object.data))
              throw TypeError(".codec.in.devices.DevicesPackage.data: array expected");
            message.data = [];
            for (let i = 0;i < object.data.length; ++i) {
              if (typeof object.data[i] !== "object")
                throw TypeError(".codec.in.devices.DevicesPackage.data: object expected");
              message.data[i] = $root.codec.in_.devices.DevicesData.fromObject(object.data[i]);
            }
          }
          return message;
        };
        DevicesPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults)
            object.data = [];
          if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0;j < message.data.length; ++j)
              object.data[j] = $root.codec.in_.devices.DevicesData.toObject(message.data[j], options);
          }
          return object;
        };
        DevicesPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        DevicesPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.devices.DevicesPackage";
        };
        return DevicesPackage;
      }();
      return devices;
    }();
    in_.firmware_update = function() {
      const firmware_update = {};
      firmware_update.FirmwareUpdatePackage = function() {
        function FirmwareUpdatePackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        FirmwareUpdatePackage.prototype.type = 0;
        FirmwareUpdatePackage.prototype.protocol = 0;
        FirmwareUpdatePackage.prototype.activation_code = 0;
        FirmwareUpdatePackage.prototype.version = 0;
        FirmwareUpdatePackage.create = function create(properties) {
          return new FirmwareUpdatePackage(properties);
        };
        FirmwareUpdatePackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
          if (message.protocol != null && Object.hasOwnProperty.call(message, "protocol"))
            writer.uint32(16).int32(message.protocol);
          if (message.activation_code != null && Object.hasOwnProperty.call(message, "activation_code"))
            writer.uint32(24).int32(message.activation_code);
          if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(32).int32(message.version);
          return writer;
        };
        FirmwareUpdatePackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        FirmwareUpdatePackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.firmware_update.FirmwareUpdatePackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.type = reader.int32();
                break;
              }
              case 2: {
                message.protocol = reader.int32();
                break;
              }
              case 3: {
                message.activation_code = reader.int32();
                break;
              }
              case 4: {
                message.version = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        FirmwareUpdatePackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        FirmwareUpdatePackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
              default:
                return "type: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.protocol != null && message.hasOwnProperty("protocol"))
            switch (message.protocol) {
              default:
                return "protocol: enum value expected";
              case 0:
              case 1:
                break;
            }
          if (message.activation_code != null && message.hasOwnProperty("activation_code")) {
            if (!$util.isInteger(message.activation_code))
              return "activation_code: integer expected";
          }
          if (message.version != null && message.hasOwnProperty("version")) {
            if (!$util.isInteger(message.version))
              return "version: integer expected";
          }
          return null;
        };
        FirmwareUpdatePackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.firmware_update.FirmwareUpdatePackage)
            return object;
          let message = new $root.codec.in_.firmware_update.FirmwareUpdatePackage;
          switch (object.type) {
            default:
              if (typeof object.type === "number") {
                message.type = object.type;
                break;
              }
              break;
            case "MSG_ESP":
            case 0:
              message.type = 0;
              break;
            case "MSG_STM":
            case 1:
              message.type = 1;
              break;
          }
          switch (object.protocol) {
            default:
              if (typeof object.protocol === "number") {
                message.protocol = object.protocol;
                break;
              }
              break;
            case "MSG_HTTPS":
            case 0:
              message.protocol = 0;
              break;
            case "MSG_HTTP":
            case 1:
              message.protocol = 1;
              break;
          }
          if (object.activation_code != null)
            message.activation_code = object.activation_code | 0;
          if (object.version != null)
            message.version = object.version | 0;
          return message;
        };
        FirmwareUpdatePackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.type = options.enums === String ? "MSG_ESP" : 0;
            object.protocol = options.enums === String ? "MSG_HTTPS" : 0;
            object.activation_code = 0;
            object.version = 0;
          }
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.codec.in_.firmware_update.MsgType[message.type] === undefined ? message.type : $root.codec.in_.firmware_update.MsgType[message.type] : message.type;
          if (message.protocol != null && message.hasOwnProperty("protocol"))
            object.protocol = options.enums === String ? $root.codec.in_.firmware_update.MsgProtocol[message.protocol] === undefined ? message.protocol : $root.codec.in_.firmware_update.MsgProtocol[message.protocol] : message.protocol;
          if (message.activation_code != null && message.hasOwnProperty("activation_code"))
            object.activation_code = message.activation_code;
          if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
          return object;
        };
        FirmwareUpdatePackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        FirmwareUpdatePackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.firmware_update.FirmwareUpdatePackage";
        };
        return FirmwareUpdatePackage;
      }();
      firmware_update.MsgType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MSG_ESP"] = 0;
        values[valuesById[1] = "MSG_STM"] = 1;
        return values;
      }();
      firmware_update.MsgProtocol = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MSG_HTTPS"] = 0;
        values[valuesById[1] = "MSG_HTTP"] = 1;
        return values;
      }();
      return firmware_update;
    }();
    in_.IncomingPacket = function() {
      function IncomingPacket(properties) {
        if (properties) {
          for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
        }
      }
      IncomingPacket.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
      IncomingPacket.prototype.config = null;
      IncomingPacket.prototype.devices = null;
      IncomingPacket.prototype.scheduling = null;
      IncomingPacket.prototype.dev_scheduling = null;
      IncomingPacket.prototype.automation = null;
      IncomingPacket.prototype.control = null;
      IncomingPacket.prototype.command = null;
      IncomingPacket.prototype.request_info = null;
      IncomingPacket.prototype.firmware_update = null;
      let $oneOfFields;
      Object.defineProperty(IncomingPacket.prototype, "payload", {
        get: $util.oneOfGetter($oneOfFields = ["config", "devices", "scheduling", "dev_scheduling", "automation", "control", "command", "request_info", "firmware_update"]),
        set: $util.oneOfSetter($oneOfFields)
      });
      IncomingPacket.create = function create(properties) {
        return new IncomingPacket(properties);
      };
      IncomingPacket.encode = function encode(message, writer) {
        if (!writer)
          writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
          writer.uint32(8).uint64(message.id);
        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
          $root.codec.in_.config.ConfigPackage.encode(message.config, writer.uint32(18).fork()).ldelim();
        if (message.devices != null && Object.hasOwnProperty.call(message, "devices"))
          $root.codec.in_.devices.DevicesPackage.encode(message.devices, writer.uint32(26).fork()).ldelim();
        if (message.scheduling != null && Object.hasOwnProperty.call(message, "scheduling"))
          $root.codec.in_.scheduling.SchedulingPackage.encode(message.scheduling, writer.uint32(34).fork()).ldelim();
        if (message.dev_scheduling != null && Object.hasOwnProperty.call(message, "dev_scheduling"))
          $root.codec.in_.device_scheduling.DeviceSchedulingPackage.encode(message.dev_scheduling, writer.uint32(42).fork()).ldelim();
        if (message.automation != null && Object.hasOwnProperty.call(message, "automation"))
          $root.codec.in_.automation.AutomationPackage.encode(message.automation, writer.uint32(50).fork()).ldelim();
        if (message.control != null && Object.hasOwnProperty.call(message, "control"))
          $root.codec.in_.control.ControlPackage.encode(message.control, writer.uint32(58).fork()).ldelim();
        if (message.command != null && Object.hasOwnProperty.call(message, "command"))
          $root.codec.in_.command.CommandPackage.encode(message.command, writer.uint32(66).fork()).ldelim();
        if (message.request_info != null && Object.hasOwnProperty.call(message, "request_info"))
          $root.codec.in_.request_info.RequestInfoPackage.encode(message.request_info, writer.uint32(74).fork()).ldelim();
        if (message.firmware_update != null && Object.hasOwnProperty.call(message, "firmware_update"))
          $root.codec.in_.firmware_update.FirmwareUpdatePackage.encode(message.firmware_update, writer.uint32(82).fork()).ldelim();
        return writer;
      };
      IncomingPacket.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };
      IncomingPacket.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
          reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.IncomingPacket;
        while (reader.pos < end) {
          let tag = reader.uint32();
          if (tag === error)
            break;
          switch (tag >>> 3) {
            case 1: {
              message.id = reader.uint64();
              break;
            }
            case 2: {
              message.config = $root.codec.in_.config.ConfigPackage.decode(reader, reader.uint32());
              break;
            }
            case 3: {
              message.devices = $root.codec.in_.devices.DevicesPackage.decode(reader, reader.uint32());
              break;
            }
            case 4: {
              message.scheduling = $root.codec.in_.scheduling.SchedulingPackage.decode(reader, reader.uint32());
              break;
            }
            case 5: {
              message.dev_scheduling = $root.codec.in_.device_scheduling.DeviceSchedulingPackage.decode(reader, reader.uint32());
              break;
            }
            case 6: {
              message.automation = $root.codec.in_.automation.AutomationPackage.decode(reader, reader.uint32());
              break;
            }
            case 7: {
              message.control = $root.codec.in_.control.ControlPackage.decode(reader, reader.uint32());
              break;
            }
            case 8: {
              message.command = $root.codec.in_.command.CommandPackage.decode(reader, reader.uint32());
              break;
            }
            case 9: {
              message.request_info = $root.codec.in_.request_info.RequestInfoPackage.decode(reader, reader.uint32());
              break;
            }
            case 10: {
              message.firmware_update = $root.codec.in_.firmware_update.FirmwareUpdatePackage.decode(reader, reader.uint32());
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };
      IncomingPacket.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
          reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };
      IncomingPacket.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
          return "object expected";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id")) {
          if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
            return "id: integer|Long expected";
        }
        if (message.config != null && message.hasOwnProperty("config")) {
          properties.payload = 1;
          {
            let error = $root.codec.in_.config.ConfigPackage.verify(message.config);
            if (error)
              return "config." + error;
          }
        }
        if (message.devices != null && message.hasOwnProperty("devices")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.devices.DevicesPackage.verify(message.devices);
            if (error)
              return "devices." + error;
          }
        }
        if (message.scheduling != null && message.hasOwnProperty("scheduling")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.scheduling.SchedulingPackage.verify(message.scheduling);
            if (error)
              return "scheduling." + error;
          }
        }
        if (message.dev_scheduling != null && message.hasOwnProperty("dev_scheduling")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.device_scheduling.DeviceSchedulingPackage.verify(message.dev_scheduling);
            if (error)
              return "dev_scheduling." + error;
          }
        }
        if (message.automation != null && message.hasOwnProperty("automation")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.automation.AutomationPackage.verify(message.automation);
            if (error)
              return "automation." + error;
          }
        }
        if (message.control != null && message.hasOwnProperty("control")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.control.ControlPackage.verify(message.control);
            if (error)
              return "control." + error;
          }
        }
        if (message.command != null && message.hasOwnProperty("command")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.command.CommandPackage.verify(message.command);
            if (error)
              return "command." + error;
          }
        }
        if (message.request_info != null && message.hasOwnProperty("request_info")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.request_info.RequestInfoPackage.verify(message.request_info);
            if (error)
              return "request_info." + error;
          }
        }
        if (message.firmware_update != null && message.hasOwnProperty("firmware_update")) {
          if (properties.payload === 1)
            return "payload: multiple values";
          properties.payload = 1;
          {
            let error = $root.codec.in_.firmware_update.FirmwareUpdatePackage.verify(message.firmware_update);
            if (error)
              return "firmware_update." + error;
          }
        }
        return null;
      };
      IncomingPacket.fromObject = function fromObject(object) {
        if (object instanceof $root.codec.in_.IncomingPacket)
          return object;
        let message = new $root.codec.in_.IncomingPacket;
        if (object.id != null) {
          if ($util.Long)
            (message.id = $util.Long.fromValue(object.id)).unsigned = true;
          else if (typeof object.id === "string")
            message.id = parseInt(object.id, 10);
          else if (typeof object.id === "number")
            message.id = object.id;
          else if (typeof object.id === "object")
            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
        }
        if (object.config != null) {
          if (typeof object.config !== "object")
            throw TypeError(".codec.in.IncomingPacket.config: object expected");
          message.config = $root.codec.in_.config.ConfigPackage.fromObject(object.config);
        }
        if (object.devices != null) {
          if (typeof object.devices !== "object")
            throw TypeError(".codec.in.IncomingPacket.devices: object expected");
          message.devices = $root.codec.in_.devices.DevicesPackage.fromObject(object.devices);
        }
        if (object.scheduling != null) {
          if (typeof object.scheduling !== "object")
            throw TypeError(".codec.in.IncomingPacket.scheduling: object expected");
          message.scheduling = $root.codec.in_.scheduling.SchedulingPackage.fromObject(object.scheduling);
        }
        if (object.dev_scheduling != null) {
          if (typeof object.dev_scheduling !== "object")
            throw TypeError(".codec.in.IncomingPacket.dev_scheduling: object expected");
          message.dev_scheduling = $root.codec.in_.device_scheduling.DeviceSchedulingPackage.fromObject(object.dev_scheduling);
        }
        if (object.automation != null) {
          if (typeof object.automation !== "object")
            throw TypeError(".codec.in.IncomingPacket.automation: object expected");
          message.automation = $root.codec.in_.automation.AutomationPackage.fromObject(object.automation);
        }
        if (object.control != null) {
          if (typeof object.control !== "object")
            throw TypeError(".codec.in.IncomingPacket.control: object expected");
          message.control = $root.codec.in_.control.ControlPackage.fromObject(object.control);
        }
        if (object.command != null) {
          if (typeof object.command !== "object")
            throw TypeError(".codec.in.IncomingPacket.command: object expected");
          message.command = $root.codec.in_.command.CommandPackage.fromObject(object.command);
        }
        if (object.request_info != null) {
          if (typeof object.request_info !== "object")
            throw TypeError(".codec.in.IncomingPacket.request_info: object expected");
          message.request_info = $root.codec.in_.request_info.RequestInfoPackage.fromObject(object.request_info);
        }
        if (object.firmware_update != null) {
          if (typeof object.firmware_update !== "object")
            throw TypeError(".codec.in.IncomingPacket.firmware_update: object expected");
          message.firmware_update = $root.codec.in_.firmware_update.FirmwareUpdatePackage.fromObject(object.firmware_update);
        }
        return message;
      };
      IncomingPacket.toObject = function toObject(message, options) {
        if (!options)
          options = {};
        let object = {};
        if (options.defaults)
          if ($util.Long) {
            let long = new $util.Long(0, 0, true);
            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else
            object.id = options.longs === String ? "0" : 0;
        if (message.id != null && message.hasOwnProperty("id"))
          if (typeof message.id === "number")
            object.id = options.longs === String ? String(message.id) : message.id;
          else
            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
        if (message.config != null && message.hasOwnProperty("config")) {
          object.config = $root.codec.in_.config.ConfigPackage.toObject(message.config, options);
          if (options.oneofs)
            object.payload = "config";
        }
        if (message.devices != null && message.hasOwnProperty("devices")) {
          object.devices = $root.codec.in_.devices.DevicesPackage.toObject(message.devices, options);
          if (options.oneofs)
            object.payload = "devices";
        }
        if (message.scheduling != null && message.hasOwnProperty("scheduling")) {
          object.scheduling = $root.codec.in_.scheduling.SchedulingPackage.toObject(message.scheduling, options);
          if (options.oneofs)
            object.payload = "scheduling";
        }
        if (message.dev_scheduling != null && message.hasOwnProperty("dev_scheduling")) {
          object.dev_scheduling = $root.codec.in_.device_scheduling.DeviceSchedulingPackage.toObject(message.dev_scheduling, options);
          if (options.oneofs)
            object.payload = "dev_scheduling";
        }
        if (message.automation != null && message.hasOwnProperty("automation")) {
          object.automation = $root.codec.in_.automation.AutomationPackage.toObject(message.automation, options);
          if (options.oneofs)
            object.payload = "automation";
        }
        if (message.control != null && message.hasOwnProperty("control")) {
          object.control = $root.codec.in_.control.ControlPackage.toObject(message.control, options);
          if (options.oneofs)
            object.payload = "control";
        }
        if (message.command != null && message.hasOwnProperty("command")) {
          object.command = $root.codec.in_.command.CommandPackage.toObject(message.command, options);
          if (options.oneofs)
            object.payload = "command";
        }
        if (message.request_info != null && message.hasOwnProperty("request_info")) {
          object.request_info = $root.codec.in_.request_info.RequestInfoPackage.toObject(message.request_info, options);
          if (options.oneofs)
            object.payload = "request_info";
        }
        if (message.firmware_update != null && message.hasOwnProperty("firmware_update")) {
          object.firmware_update = $root.codec.in_.firmware_update.FirmwareUpdatePackage.toObject(message.firmware_update, options);
          if (options.oneofs)
            object.payload = "firmware_update";
        }
        return object;
      };
      IncomingPacket.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };
      IncomingPacket.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
          typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/codec.in_.IncomingPacket";
      };
      return IncomingPacket;
    }();
    in_.scheduling = function() {
      const scheduling = {};
      scheduling.Scheduling = function() {
        function Scheduling(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        Scheduling.prototype.idx = 0;
        Scheduling.prototype.start_time = 0;
        Scheduling.prototype.days_of_week = 0;
        Scheduling.prototype.number_of_steps = 0;
        Scheduling.prototype.waterpump_idx = 0;
        Scheduling.prototype.waterpump_working_time = 0;
        Scheduling.prototype.allow_ferti = false;
        Scheduling.prototype.ferti_idx = 0;
        Scheduling.prototype.allow_backwash = false;
        Scheduling.prototype.backwash_idx = 0;
        Scheduling.prototype.group = 0;
        Scheduling.prototype.once = false;
        Scheduling.create = function create(properties) {
          return new Scheduling(properties);
        };
        Scheduling.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
            writer.uint32(8).int32(message.idx);
          if (message.start_time != null && Object.hasOwnProperty.call(message, "start_time"))
            writer.uint32(16).int32(message.start_time);
          if (message.days_of_week != null && Object.hasOwnProperty.call(message, "days_of_week"))
            writer.uint32(24).int32(message.days_of_week);
          if (message.number_of_steps != null && Object.hasOwnProperty.call(message, "number_of_steps"))
            writer.uint32(32).int32(message.number_of_steps);
          if (message.waterpump_idx != null && Object.hasOwnProperty.call(message, "waterpump_idx"))
            writer.uint32(40).int32(message.waterpump_idx);
          if (message.waterpump_working_time != null && Object.hasOwnProperty.call(message, "waterpump_working_time"))
            writer.uint32(48).int32(message.waterpump_working_time);
          if (message.allow_ferti != null && Object.hasOwnProperty.call(message, "allow_ferti"))
            writer.uint32(56).bool(message.allow_ferti);
          if (message.ferti_idx != null && Object.hasOwnProperty.call(message, "ferti_idx"))
            writer.uint32(64).int32(message.ferti_idx);
          if (message.allow_backwash != null && Object.hasOwnProperty.call(message, "allow_backwash"))
            writer.uint32(72).bool(message.allow_backwash);
          if (message.backwash_idx != null && Object.hasOwnProperty.call(message, "backwash_idx"))
            writer.uint32(80).int32(message.backwash_idx);
          if (message.group != null && Object.hasOwnProperty.call(message, "group"))
            writer.uint32(88).int32(message.group);
          if (message.once != null && Object.hasOwnProperty.call(message, "once"))
            writer.uint32(96).bool(message.once);
          return writer;
        };
        Scheduling.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        Scheduling.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.scheduling.Scheduling;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.idx = reader.int32();
                break;
              }
              case 2: {
                message.start_time = reader.int32();
                break;
              }
              case 3: {
                message.days_of_week = reader.int32();
                break;
              }
              case 4: {
                message.number_of_steps = reader.int32();
                break;
              }
              case 5: {
                message.waterpump_idx = reader.int32();
                break;
              }
              case 6: {
                message.waterpump_working_time = reader.int32();
                break;
              }
              case 7: {
                message.allow_ferti = reader.bool();
                break;
              }
              case 8: {
                message.ferti_idx = reader.int32();
                break;
              }
              case 9: {
                message.allow_backwash = reader.bool();
                break;
              }
              case 10: {
                message.backwash_idx = reader.int32();
                break;
              }
              case 11: {
                message.group = reader.int32();
                break;
              }
              case 12: {
                message.once = reader.bool();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        Scheduling.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        Scheduling.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.idx != null && message.hasOwnProperty("idx")) {
            if (!$util.isInteger(message.idx))
              return "idx: integer expected";
          }
          if (message.start_time != null && message.hasOwnProperty("start_time")) {
            if (!$util.isInteger(message.start_time))
              return "start_time: integer expected";
          }
          if (message.days_of_week != null && message.hasOwnProperty("days_of_week")) {
            if (!$util.isInteger(message.days_of_week))
              return "days_of_week: integer expected";
          }
          if (message.number_of_steps != null && message.hasOwnProperty("number_of_steps")) {
            if (!$util.isInteger(message.number_of_steps))
              return "number_of_steps: integer expected";
          }
          if (message.waterpump_idx != null && message.hasOwnProperty("waterpump_idx")) {
            if (!$util.isInteger(message.waterpump_idx))
              return "waterpump_idx: integer expected";
          }
          if (message.waterpump_working_time != null && message.hasOwnProperty("waterpump_working_time")) {
            if (!$util.isInteger(message.waterpump_working_time))
              return "waterpump_working_time: integer expected";
          }
          if (message.allow_ferti != null && message.hasOwnProperty("allow_ferti")) {
            if (typeof message.allow_ferti !== "boolean")
              return "allow_ferti: boolean expected";
          }
          if (message.ferti_idx != null && message.hasOwnProperty("ferti_idx")) {
            if (!$util.isInteger(message.ferti_idx))
              return "ferti_idx: integer expected";
          }
          if (message.allow_backwash != null && message.hasOwnProperty("allow_backwash")) {
            if (typeof message.allow_backwash !== "boolean")
              return "allow_backwash: boolean expected";
          }
          if (message.backwash_idx != null && message.hasOwnProperty("backwash_idx")) {
            if (!$util.isInteger(message.backwash_idx))
              return "backwash_idx: integer expected";
          }
          if (message.group != null && message.hasOwnProperty("group")) {
            if (!$util.isInteger(message.group))
              return "group: integer expected";
          }
          if (message.once != null && message.hasOwnProperty("once")) {
            if (typeof message.once !== "boolean")
              return "once: boolean expected";
          }
          return null;
        };
        Scheduling.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.scheduling.Scheduling)
            return object;
          let message = new $root.codec.in_.scheduling.Scheduling;
          if (object.idx != null)
            message.idx = object.idx | 0;
          if (object.start_time != null)
            message.start_time = object.start_time | 0;
          if (object.days_of_week != null)
            message.days_of_week = object.days_of_week | 0;
          if (object.number_of_steps != null)
            message.number_of_steps = object.number_of_steps | 0;
          if (object.waterpump_idx != null)
            message.waterpump_idx = object.waterpump_idx | 0;
          if (object.waterpump_working_time != null)
            message.waterpump_working_time = object.waterpump_working_time | 0;
          if (object.allow_ferti != null)
            message.allow_ferti = Boolean(object.allow_ferti);
          if (object.ferti_idx != null)
            message.ferti_idx = object.ferti_idx | 0;
          if (object.allow_backwash != null)
            message.allow_backwash = Boolean(object.allow_backwash);
          if (object.backwash_idx != null)
            message.backwash_idx = object.backwash_idx | 0;
          if (object.group != null)
            message.group = object.group | 0;
          if (object.once != null)
            message.once = Boolean(object.once);
          return message;
        };
        Scheduling.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.idx = 0;
            object.start_time = 0;
            object.days_of_week = 0;
            object.number_of_steps = 0;
            object.waterpump_idx = 0;
            object.waterpump_working_time = 0;
            object.allow_ferti = false;
            object.ferti_idx = 0;
            object.allow_backwash = false;
            object.backwash_idx = 0;
            object.group = 0;
            object.once = false;
          }
          if (message.idx != null && message.hasOwnProperty("idx"))
            object.idx = message.idx;
          if (message.start_time != null && message.hasOwnProperty("start_time"))
            object.start_time = message.start_time;
          if (message.days_of_week != null && message.hasOwnProperty("days_of_week"))
            object.days_of_week = message.days_of_week;
          if (message.number_of_steps != null && message.hasOwnProperty("number_of_steps"))
            object.number_of_steps = message.number_of_steps;
          if (message.waterpump_idx != null && message.hasOwnProperty("waterpump_idx"))
            object.waterpump_idx = message.waterpump_idx;
          if (message.waterpump_working_time != null && message.hasOwnProperty("waterpump_working_time"))
            object.waterpump_working_time = message.waterpump_working_time;
          if (message.allow_ferti != null && message.hasOwnProperty("allow_ferti"))
            object.allow_ferti = message.allow_ferti;
          if (message.ferti_idx != null && message.hasOwnProperty("ferti_idx"))
            object.ferti_idx = message.ferti_idx;
          if (message.allow_backwash != null && message.hasOwnProperty("allow_backwash"))
            object.allow_backwash = message.allow_backwash;
          if (message.backwash_idx != null && message.hasOwnProperty("backwash_idx"))
            object.backwash_idx = message.backwash_idx;
          if (message.group != null && message.hasOwnProperty("group"))
            object.group = message.group;
          if (message.once != null && message.hasOwnProperty("once"))
            object.once = message.once;
          return object;
        };
        Scheduling.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        Scheduling.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.scheduling.Scheduling";
        };
        return Scheduling;
      }();
      scheduling.DeviceScheduling = function() {
        function DeviceScheduling(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        DeviceScheduling.prototype.idx = 0;
        DeviceScheduling.prototype.scheduling_idx = 0;
        DeviceScheduling.prototype.device_idx = 0;
        DeviceScheduling.prototype.order = 0;
        DeviceScheduling.prototype.sector_working_time = 0;
        DeviceScheduling.prototype.ferti_working_time = 0;
        DeviceScheduling.prototype.ferti_delay = 0;
        DeviceScheduling.create = function create(properties) {
          return new DeviceScheduling(properties);
        };
        DeviceScheduling.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.idx != null && Object.hasOwnProperty.call(message, "idx"))
            writer.uint32(8).int32(message.idx);
          if (message.scheduling_idx != null && Object.hasOwnProperty.call(message, "scheduling_idx"))
            writer.uint32(16).int32(message.scheduling_idx);
          if (message.device_idx != null && Object.hasOwnProperty.call(message, "device_idx"))
            writer.uint32(24).int32(message.device_idx);
          if (message.order != null && Object.hasOwnProperty.call(message, "order"))
            writer.uint32(32).int32(message.order);
          if (message.sector_working_time != null && Object.hasOwnProperty.call(message, "sector_working_time"))
            writer.uint32(40).int32(message.sector_working_time);
          if (message.ferti_working_time != null && Object.hasOwnProperty.call(message, "ferti_working_time"))
            writer.uint32(48).int32(message.ferti_working_time);
          if (message.ferti_delay != null && Object.hasOwnProperty.call(message, "ferti_delay"))
            writer.uint32(56).int32(message.ferti_delay);
          return writer;
        };
        DeviceScheduling.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        DeviceScheduling.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.scheduling.DeviceScheduling;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.idx = reader.int32();
                break;
              }
              case 2: {
                message.scheduling_idx = reader.int32();
                break;
              }
              case 3: {
                message.device_idx = reader.int32();
                break;
              }
              case 4: {
                message.order = reader.int32();
                break;
              }
              case 5: {
                message.sector_working_time = reader.int32();
                break;
              }
              case 6: {
                message.ferti_working_time = reader.int32();
                break;
              }
              case 7: {
                message.ferti_delay = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        DeviceScheduling.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        DeviceScheduling.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.idx != null && message.hasOwnProperty("idx")) {
            if (!$util.isInteger(message.idx))
              return "idx: integer expected";
          }
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx")) {
            if (!$util.isInteger(message.scheduling_idx))
              return "scheduling_idx: integer expected";
          }
          if (message.device_idx != null && message.hasOwnProperty("device_idx")) {
            if (!$util.isInteger(message.device_idx))
              return "device_idx: integer expected";
          }
          if (message.order != null && message.hasOwnProperty("order")) {
            if (!$util.isInteger(message.order))
              return "order: integer expected";
          }
          if (message.sector_working_time != null && message.hasOwnProperty("sector_working_time")) {
            if (!$util.isInteger(message.sector_working_time))
              return "sector_working_time: integer expected";
          }
          if (message.ferti_working_time != null && message.hasOwnProperty("ferti_working_time")) {
            if (!$util.isInteger(message.ferti_working_time))
              return "ferti_working_time: integer expected";
          }
          if (message.ferti_delay != null && message.hasOwnProperty("ferti_delay")) {
            if (!$util.isInteger(message.ferti_delay))
              return "ferti_delay: integer expected";
          }
          return null;
        };
        DeviceScheduling.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.scheduling.DeviceScheduling)
            return object;
          let message = new $root.codec.in_.scheduling.DeviceScheduling;
          if (object.idx != null)
            message.idx = object.idx | 0;
          if (object.scheduling_idx != null)
            message.scheduling_idx = object.scheduling_idx | 0;
          if (object.device_idx != null)
            message.device_idx = object.device_idx | 0;
          if (object.order != null)
            message.order = object.order | 0;
          if (object.sector_working_time != null)
            message.sector_working_time = object.sector_working_time | 0;
          if (object.ferti_working_time != null)
            message.ferti_working_time = object.ferti_working_time | 0;
          if (object.ferti_delay != null)
            message.ferti_delay = object.ferti_delay | 0;
          return message;
        };
        DeviceScheduling.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults) {
            object.idx = 0;
            object.scheduling_idx = 0;
            object.device_idx = 0;
            object.order = 0;
            object.sector_working_time = 0;
            object.ferti_working_time = 0;
            object.ferti_delay = 0;
          }
          if (message.idx != null && message.hasOwnProperty("idx"))
            object.idx = message.idx;
          if (message.scheduling_idx != null && message.hasOwnProperty("scheduling_idx"))
            object.scheduling_idx = message.scheduling_idx;
          if (message.device_idx != null && message.hasOwnProperty("device_idx"))
            object.device_idx = message.device_idx;
          if (message.order != null && message.hasOwnProperty("order"))
            object.order = message.order;
          if (message.sector_working_time != null && message.hasOwnProperty("sector_working_time"))
            object.sector_working_time = message.sector_working_time;
          if (message.ferti_working_time != null && message.hasOwnProperty("ferti_working_time"))
            object.ferti_working_time = message.ferti_working_time;
          if (message.ferti_delay != null && message.hasOwnProperty("ferti_delay"))
            object.ferti_delay = message.ferti_delay;
          return object;
        };
        DeviceScheduling.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        DeviceScheduling.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.scheduling.DeviceScheduling";
        };
        return DeviceScheduling;
      }();
      scheduling.SchedulingPackage = function() {
        function SchedulingPackage(properties) {
          this.scheduling_data = [];
          this.device_scheduling_data = [];
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        SchedulingPackage.prototype.type = 0;
        SchedulingPackage.prototype.scheduling_data = $util.emptyArray;
        SchedulingPackage.prototype.device_scheduling_data = $util.emptyArray;
        SchedulingPackage.create = function create(properties) {
          return new SchedulingPackage(properties);
        };
        SchedulingPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
          if (message.scheduling_data != null && message.scheduling_data.length)
            for (let i = 0;i < message.scheduling_data.length; ++i)
              $root.codec.in_.scheduling.Scheduling.encode(message.scheduling_data[i], writer.uint32(18).fork()).ldelim();
          if (message.device_scheduling_data != null && message.device_scheduling_data.length)
            for (let i = 0;i < message.device_scheduling_data.length; ++i)
              $root.codec.in_.scheduling.DeviceScheduling.encode(message.device_scheduling_data[i], writer.uint32(26).fork()).ldelim();
          return writer;
        };
        SchedulingPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        SchedulingPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.scheduling.SchedulingPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.type = reader.int32();
                break;
              }
              case 2: {
                if (!(message.scheduling_data && message.scheduling_data.length))
                  message.scheduling_data = [];
                message.scheduling_data.push($root.codec.in_.scheduling.Scheduling.decode(reader, reader.uint32()));
                break;
              }
              case 3: {
                if (!(message.device_scheduling_data && message.device_scheduling_data.length))
                  message.device_scheduling_data = [];
                message.device_scheduling_data.push($root.codec.in_.scheduling.DeviceScheduling.decode(reader, reader.uint32()));
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        SchedulingPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        SchedulingPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
              default:
                return "type: enum value expected";
              case 0:
              case 1:
              case 2:
              case 3:
                break;
            }
          if (message.scheduling_data != null && message.hasOwnProperty("scheduling_data")) {
            if (!Array.isArray(message.scheduling_data))
              return "scheduling_data: array expected";
            for (let i = 0;i < message.scheduling_data.length; ++i) {
              let error = $root.codec.in_.scheduling.Scheduling.verify(message.scheduling_data[i]);
              if (error)
                return "scheduling_data." + error;
            }
          }
          if (message.device_scheduling_data != null && message.hasOwnProperty("device_scheduling_data")) {
            if (!Array.isArray(message.device_scheduling_data))
              return "device_scheduling_data: array expected";
            for (let i = 0;i < message.device_scheduling_data.length; ++i) {
              let error = $root.codec.in_.scheduling.DeviceScheduling.verify(message.device_scheduling_data[i]);
              if (error)
                return "device_scheduling_data." + error;
            }
          }
          return null;
        };
        SchedulingPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.scheduling.SchedulingPackage)
            return object;
          let message = new $root.codec.in_.scheduling.SchedulingPackage;
          switch (object.type) {
            default:
              if (typeof object.type === "number") {
                message.type = object.type;
                break;
              }
              break;
            case "MSG_NONE":
            case 0:
              message.type = 0;
              break;
            case "MSG_SCHEDULING_ONLY":
            case 1:
              message.type = 1;
              break;
            case "MSG_DEV_SCHEDULING_ONLY":
            case 2:
              message.type = 2;
              break;
            case "MSG_SCHEDULING_ALL":
            case 3:
              message.type = 3;
              break;
          }
          if (object.scheduling_data) {
            if (!Array.isArray(object.scheduling_data))
              throw TypeError(".codec.in.scheduling.SchedulingPackage.scheduling_data: array expected");
            message.scheduling_data = [];
            for (let i = 0;i < object.scheduling_data.length; ++i) {
              if (typeof object.scheduling_data[i] !== "object")
                throw TypeError(".codec.in.scheduling.SchedulingPackage.scheduling_data: object expected");
              message.scheduling_data[i] = $root.codec.in_.scheduling.Scheduling.fromObject(object.scheduling_data[i]);
            }
          }
          if (object.device_scheduling_data) {
            if (!Array.isArray(object.device_scheduling_data))
              throw TypeError(".codec.in.scheduling.SchedulingPackage.device_scheduling_data: array expected");
            message.device_scheduling_data = [];
            for (let i = 0;i < object.device_scheduling_data.length; ++i) {
              if (typeof object.device_scheduling_data[i] !== "object")
                throw TypeError(".codec.in.scheduling.SchedulingPackage.device_scheduling_data: object expected");
              message.device_scheduling_data[i] = $root.codec.in_.scheduling.DeviceScheduling.fromObject(object.device_scheduling_data[i]);
            }
          }
          return message;
        };
        SchedulingPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.arrays || options.defaults) {
            object.scheduling_data = [];
            object.device_scheduling_data = [];
          }
          if (options.defaults)
            object.type = options.enums === String ? "MSG_NONE" : 0;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.codec.in_.scheduling.MsgType[message.type] === undefined ? message.type : $root.codec.in_.scheduling.MsgType[message.type] : message.type;
          if (message.scheduling_data && message.scheduling_data.length) {
            object.scheduling_data = [];
            for (let j = 0;j < message.scheduling_data.length; ++j)
              object.scheduling_data[j] = $root.codec.in_.scheduling.Scheduling.toObject(message.scheduling_data[j], options);
          }
          if (message.device_scheduling_data && message.device_scheduling_data.length) {
            object.device_scheduling_data = [];
            for (let j = 0;j < message.device_scheduling_data.length; ++j)
              object.device_scheduling_data[j] = $root.codec.in_.scheduling.DeviceScheduling.toObject(message.device_scheduling_data[j], options);
          }
          return object;
        };
        SchedulingPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        SchedulingPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.scheduling.SchedulingPackage";
        };
        return SchedulingPackage;
      }();
      scheduling.MsgType = function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MSG_NONE"] = 0;
        values[valuesById[1] = "MSG_SCHEDULING_ONLY"] = 1;
        values[valuesById[2] = "MSG_DEV_SCHEDULING_ONLY"] = 2;
        values[valuesById[3] = "MSG_SCHEDULING_ALL"] = 3;
        return values;
      }();
      return scheduling;
    }();
    in_.request_info = function() {
      const request_info = {};
      request_info.RequestInfoPackage = function() {
        function RequestInfoPackage(properties) {
          if (properties) {
            for (let keys = Object.keys(properties), i = 0;i < keys.length; ++i)
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
          }
        }
        RequestInfoPackage.prototype.type = 0;
        RequestInfoPackage.create = function create(properties) {
          return new RequestInfoPackage(properties);
        };
        RequestInfoPackage.encode = function encode(message, writer) {
          if (!writer)
            writer = $Writer.create();
          if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).int32(message.type);
          return writer;
        };
        RequestInfoPackage.encodeDelimited = function encodeDelimited(message, writer) {
          return this.encode(message, writer).ldelim();
        };
        RequestInfoPackage.decode = function decode(reader, length, error) {
          if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length, message = new $root.codec.in_.request_info.RequestInfoPackage;
          while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
              break;
            switch (tag >>> 3) {
              case 1: {
                message.type = reader.int32();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };
        RequestInfoPackage.decodeDelimited = function decodeDelimited(reader) {
          if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
          return this.decode(reader, reader.uint32());
        };
        RequestInfoPackage.verify = function verify(message) {
          if (typeof message !== "object" || message === null)
            return "object expected";
          if (message.type != null && message.hasOwnProperty("type")) {
            if (!$util.isInteger(message.type))
              return "type: integer expected";
          }
          return null;
        };
        RequestInfoPackage.fromObject = function fromObject(object) {
          if (object instanceof $root.codec.in_.request_info.RequestInfoPackage)
            return object;
          let message = new $root.codec.in_.request_info.RequestInfoPackage;
          if (object.type != null)
            message.type = object.type | 0;
          return message;
        };
        RequestInfoPackage.toObject = function toObject(message, options) {
          if (!options)
            options = {};
          let object = {};
          if (options.defaults)
            object.type = 0;
          if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
          return object;
        };
        RequestInfoPackage.prototype.toJSON = function toJSON() {
          return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        RequestInfoPackage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
          if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
          }
          return typeUrlPrefix + "/codec.in_.request_info.RequestInfoPackage";
        };
        return RequestInfoPackage;
      }();
      return request_info;
    }();
    return in_;
  }();
  return codec2;
})();

// src/crc.ts
function crc16(input) {
  const bytes = typeof input === "string" ? new TextEncoder().encode(input) : input instanceof Uint8Array ? input : Uint8Array.from(input);
  let crc = 65535;
  for (let i = 0;i < bytes.length; i++) {
    crc ^= bytes[i] & 255;
    for (let j = 0;j < 8; j++) {
      if ((crc & 1) !== 0) {
        crc = crc >>> 1 ^ 40961;
      } else {
        crc = crc >>> 1;
      }
    }
  }
  return crc & 65535;
}
function appendCRC16(payload) {
  const crc = crc16(payload);
  let crcBytes;
  if (typeof Buffer !== "undefined" && typeof Buffer.from === "function") {
    crcBytes = Buffer.from([
      crc >> 8 & 255,
      crc & 255
    ]);
  } else {
    crcBytes = new Uint8Array([
      crc >> 8 & 255,
      crc & 255
    ]);
  }
  return new Uint8Array([...payload, ...crcBytes]);
}

// src/index.ts
var USERNAME = "byagro";
var PASSWORD = "i8dEYH7tcNxVf18";
function getAuthHeader({ user, pass }) {
  const credentials = `${user}:${pass}`;
  if (typeof Buffer !== "undefined" && typeof Buffer.from === "function") {
    return "Basic " + Buffer.from(credentials, "utf8").toString("base64");
  }
  if (typeof btoa === "function") {
    return "Basic " + btoa(unescape(encodeURIComponent(credentials)));
  }
  throw new Error("No base64 encoding available in this environment");
}
function isIP(ip) {
  const parts = ip.trim().split(".");
  if (parts.length !== 4)
    return false;
  return parts.every((part) => {
    const n = Number(part);
    return Number.isInteger(n) && n >= 0 && n <= 255;
  });
}
function buildUrl(ip, endpoint) {
  if (isIP(ip)) {
    return `http://${ip}/${endpoint}`;
  }
  if (ip.endsWith(`/${endpoint}`)) {
    return ip;
  }
  if (ip.endsWith("/")) {
    return ip + endpoint;
  }
  return ip + "/" + endpoint;
}
var REPORT_TYPES = {
  info: 2,
  status: 3
};
async function requestCodecReport(ip, reportType, auth) {
  const url = buildUrl(ip, "report");
  const headers = {
    Authorization: getAuthHeader(auth),
    "Content-Type": "application/x-protobuf"
  };
  const body = new Uint8Array([REPORT_TYPES[reportType]]);
  return fetch(url, {
    method: "POST",
    headers,
    body
  }).then(async (response) => {
    if (!response.ok)
      throw new Error(`Failed to fetch codec info from ${ip}: ${response.status} - ${response.statusText} - ${JSON.stringify(response.headers)}`);
    const buffer = await response.arrayBuffer();
    const packet = codec.out.OutgoingPacket.decode(new Uint8Array(buffer));
    return packet;
  });
}
async function postDataToCodec(ip, incomingPacket, auth) {
  const url = buildUrl(ip, "data");
  const headers = {
    Authorization: getAuthHeader(auth),
    "Content-Type": "application/octet-stream"
  };
  const body = codec.in_.IncomingPacket.encode(incomingPacket).finish();
  const payloadBytes = appendCRC16(body);
  return fetch(url, {
    method: "POST",
    headers,
    body: payloadBytes
  }).then(async (response) => {
    if (!response.ok)
      throw new Error(`Failed to post IncomingPacket to codec at ${ip}: ${response.status} - ${response.statusText} - ${JSON.stringify(response.headers)}`);
    const buffer = await response.arrayBuffer();
    return new Uint8Array(buffer);
  });
}
if (import.meta.main) {
  requestCodecReport("192.168.2.52", "status", {
    user: USERNAME,
    pass: PASSWORD
  }).then((data) => {
    console.log(data.toJSON());
  }).catch((error) => {
    console.error(error);
  });
}
export {
  requestCodecReport,
  postDataToCodec,
  REPORT_TYPES
};

//# debugId=905545A60DFE984264756E2164756E21
